var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--icons--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.82,152.84A17.13,17.13,0,1,1,63,135.71,17.14,17.14,0,0,1,45.82,152.84Zm0-33.51A16.38,16.38,0,1,0,62.2,135.71,16.39,16.39,0,0,0,45.82,119.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-17",
    d: "M41.31,126.59,39,137.15a2.94,2.94,0,0,0-.89-.37,2.83,2.83,0,1,0,2.18,3.36l2-9.47,10.08-.45h0l-2,9.39a2.94,2.94,0,0,0-.89-.37,2.83,2.83,0,1,0,2.18,3.36h0l3.35-15.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.2,173.5a10.93,10.93,0,1,1,10.94-10.93A10.94,10.94,0,0,1,395.2,173.5Zm0-21.11a10.18,10.18,0,1,0,10.19,10.18A10.2,10.2,0,0,0,395.2,152.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Pin--inject-17",
    d: "M395.2,155.52a5,5,0,0,0-4.95,5c0,4.7,4.95,9.14,4.95,9.14s5-4.44,5-9.14A5,5,0,0,0,395.2,155.52Zm0,7a2.4,2.4,0,1,1,2.4-2.4A2.4,2.4,0,0,1,395.2,162.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.58,428.49a19,19,0,1,1,19-19A19,19,0,0,1,193.58,428.49Zm0-37.24a18.25,18.25,0,1,0,18.25,18.25A18.27,18.27,0,0,0,193.58,391.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.22,400.74H183a1.61,1.61,0,0,0-1.62,1.61v13A1.61,1.61,0,0,0,183,417h7.92l2.1,4.21a.68.68,0,0,0,1.22,0L196.3,417h7.92a1.61,1.61,0,0,0,1.61-1.61v-13A1.61,1.61,0,0,0,204.22,400.74Zm-8.95,12.49-1.69,1.08-1.69-1.08c-1.25-.8-4.58-2.93-4.58-6.22a3.15,3.15,0,0,1,6.27-.41,3.15,3.15,0,0,1,6.27.41C199.85,410.3,196.52,412.43,195.27,413.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,95.84a17.42,17.42,0,1,1,17.42-17.42A17.43,17.43,0,0,1,250,95.84Zm0-34.09a16.67,16.67,0,1,0,16.67,16.67A16.68,16.68,0,0,0,250,61.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.08,78.87H243.93a3.33,3.33,0,0,0-3.3,2.82l-.81,5.25c3.08,7,17.28,7,20.37,0l-.82-5.25A3.32,3.32,0,0,0,256.08,78.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 70.97,
    r: 5.78,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.32,149.92a19.23,19.23,0,1,1,19.22-19.23A19.26,19.26,0,0,1,465.32,149.92Zm0-37.71a18.48,18.48,0,1,0,18.47,18.48A18.5,18.5,0,0,0,465.32,112.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.6,133.83a3.52,3.52,0,0,1-3.52,3.52h-9.57v-4h2.69l-4.88-5.92-4.89,5.92h2.69v4h-9.57a3.52,3.52,0,0,1,0-7h1.06v-.62a5.7,5.7,0,0,1,5.72-5.72,5.64,5.64,0,0,1,3.14,1,6.41,6.41,0,0,1,12.54,1.9v3.49h1.07A3.51,3.51,0,0,1,480.6,133.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.7,428.62a13.41,13.41,0,1,1,13.41-13.41A13.43,13.43,0,0,1,293.7,428.62Zm0-26.07a12.66,12.66,0,1,0,12.66,12.66A12.68,12.68,0,0,0,293.7,402.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.84,424.05h-2.47a.87.87,0,0,1-.62-.26.85.85,0,0,1-.26-.62v-1.1a6.76,6.76,0,0,1-1.43-.56,5.75,5.75,0,0,1-1.32-.93,4.18,4.18,0,0,1-.88-1.17,3.15,3.15,0,0,1-.34-1.31.79.79,0,0,1,.23-.57.76.76,0,0,1,.54-.23h2.46a1.51,1.51,0,0,1,.57.09,1.81,1.81,0,0,1,.4.26l.26.28a1.75,1.75,0,0,0,.34.29,2.08,2.08,0,0,0,.54.27,2.78,2.78,0,0,0,.83.11,5.12,5.12,0,0,0,1.55-.2c.41-.13.41-.32.41-.43a.21.21,0,0,0-.1-.17,2.23,2.23,0,0,0-.62-.29,11.84,11.84,0,0,0-1.21-.3c-.51-.1-1.11-.22-1.8-.38a5.58,5.58,0,0,1-3-1.49,4,4,0,0,1-1-2.84,3.76,3.76,0,0,1,.27-1.41,4.14,4.14,0,0,1,.77-1.24,5.46,5.46,0,0,1,1.23-1,6.29,6.29,0,0,1,1.32-.54v-1.1a.89.89,0,0,1,.88-.89h2.47a.85.85,0,0,1,.62.26.89.89,0,0,1,.26.63v1.12a6,6,0,0,1,1.34.55,5.56,5.56,0,0,1,1.26.93,4.53,4.53,0,0,1,.84,1.1,2.85,2.85,0,0,1,.35,1.18.8.8,0,0,1-.24.57.74.74,0,0,1-.53.23h-2.47a1.44,1.44,0,0,1-.59-.11,2,2,0,0,1-.41-.29c-.06,0-.12-.12-.21-.21a1,1,0,0,0-.27-.21,1.88,1.88,0,0,0-.47-.21,3.78,3.78,0,0,0-1.36,0,2,2,0,0,0-.49.13.53.53,0,0,0-.27.19.29.29,0,0,0-.07.22.28.28,0,0,0,.07.21,1.25,1.25,0,0,0,.47.26,8.15,8.15,0,0,0,1.06.3l1.73.35a10.27,10.27,0,0,1,1.88.55,4.76,4.76,0,0,1,1.4.87,3.53,3.53,0,0,1,.86,1.27,4.46,4.46,0,0,1,.28,1.67,3.82,3.82,0,0,1-.33,1.6,4.09,4.09,0,0,1-.93,1.29,5.32,5.32,0,0,1-1.43.92,6.64,6.64,0,0,1-1.47.45v1a.89.89,0,0,1-.88.88Zm-6.55-6a2.2,2.2,0,0,0,.24,1,3.55,3.55,0,0,0,.72,1,5.41,5.41,0,0,0,1.16.81,6.22,6.22,0,0,0,1.54.56l.29.07v1.69a.12.12,0,0,0,0,.09.09.09,0,0,0,.09,0h2.47a.14.14,0,0,0,.13-.13v-1.66l.32-.05a6.48,6.48,0,0,0,1.6-.46,4.35,4.35,0,0,0,1.21-.78,3,3,0,0,0,1-2.34,3.91,3.91,0,0,0-.23-1.4,2.64,2.64,0,0,0-.67-1,4.15,4.15,0,0,0-1.18-.73,9.55,9.55,0,0,0-1.74-.5l-1.74-.36a7.47,7.47,0,0,1-1.17-.33,1.83,1.83,0,0,1-.74-.44,1.11,1.11,0,0,1,0-1.44,1.46,1.46,0,0,1,.56-.4,3,3,0,0,1,.67-.17,4.17,4.17,0,0,1,1.67.07,2.91,2.91,0,0,1,.66.28,2.27,2.27,0,0,1,.42.34l.17.18a1.43,1.43,0,0,0,.22.15.76.76,0,0,0,.27,0h2.47a1.75,1.75,0,0,0-.24-.88,3.92,3.92,0,0,0-.71-.92,5.49,5.49,0,0,0-1.09-.8,5.91,5.91,0,0,0-1.44-.56L295,409v-1.7a.11.11,0,0,0,0-.1.12.12,0,0,0-.09,0h-2.47a.12.12,0,0,0-.09,0,.14.14,0,0,0,0,.1v1.68L292,409a5.83,5.83,0,0,0-1.42.55,4.2,4.2,0,0,0-1,.81,3.26,3.26,0,0,0-.64,1,3.1,3.1,0,0,0-.21,1.13,3.29,3.29,0,0,0,.79,2.33,4.91,4.91,0,0,0,2.64,1.27l1.79.38a11,11,0,0,1,1.29.32,2.69,2.69,0,0,1,.85.41.92.92,0,0,1,.39.76,1.16,1.16,0,0,1-.93,1.14,5.72,5.72,0,0,1-1.78.24,3,3,0,0,1-1.81-.52,2.64,2.64,0,0,1-.46-.4l-.22-.23-.18-.12a.83.83,0,0,0-.27,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.4,338.91a14,14,0,1,1,14-13.94A14,14,0,0,1,409.4,338.91Zm0-27.15A13.2,13.2,0,1,0,422.6,325,13.22,13.22,0,0,0,409.4,311.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.56,323.87l-8.83-4.72a1.24,1.24,0,0,0-1.83,1.09v9.45a1.24,1.24,0,0,0,1.83,1.09l8.83-4.72A1.25,1.25,0,0,0,415.56,323.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7,348.07a10.83,10.83,0,1,1,10.82-10.83A10.84,10.84,0,0,1,38.7,348.07Zm0-20.9a10.08,10.08,0,1,0,10.07,10.07A10.08,10.08,0,0,0,38.7,327.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.56,335.38a.16.16,0,0,0,.09-.19A8.55,8.55,0,0,0,45.2,334a7.35,7.35,0,0,0-.64-1.05.15.15,0,0,0-.2-.05l-1.09.53a5.8,5.8,0,0,0-1.42-1.25l.39-1.15a.16.16,0,0,0-.08-.19,7.09,7.09,0,0,0-2.32-.79.15.15,0,0,0-.18.11l-.39,1.14a5.8,5.8,0,0,0-1.9.12l-.53-1.08a.18.18,0,0,0-.2-.09,8.43,8.43,0,0,0-1.14.45,8.34,8.34,0,0,0-1,.63.16.16,0,0,0-.05.21l.53,1.09a5.87,5.87,0,0,0-1.26,1.42l-1.14-.39a.16.16,0,0,0-.19.08,7.11,7.11,0,0,0-.8,2.32.17.17,0,0,0,.11.18l1.15.39a5.8,5.8,0,0,0,.12,1.9l-1.08.53a.17.17,0,0,0-.09.19,6.23,6.23,0,0,0,.45,1.15,6.79,6.79,0,0,0,.63,1.05.16.16,0,0,0,.21.05l1.08-.53a5.85,5.85,0,0,0,1.43,1.25l-.39,1.15a.17.17,0,0,0,.08.2,7.07,7.07,0,0,0,2.32.78.15.15,0,0,0,.18-.11l.39-1.14A5.76,5.76,0,0,0,40,343l.54,1.08a.17.17,0,0,0,.19.09,7.4,7.4,0,0,0,1.15-.45,7.89,7.89,0,0,0,1.05-.63.16.16,0,0,0,0-.21l-.53-1.08a6,6,0,0,0,1.25-1.43l1.14.39a.18.18,0,0,0,.2-.08,7.09,7.09,0,0,0,.79-2.32.17.17,0,0,0-.11-.18l-1.14-.39a6,6,0,0,0-.12-1.89Zm-4.51,4.31a3.41,3.41,0,0,1-5.74-2.09,3.27,3.27,0,0,1,1-2.81,3.41,3.41,0,0,1,5.74,2.09A3.24,3.24,0,0,1,41.05,339.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.52,41.2A12.23,12.23,0,1,1,213.74,29,12.24,12.24,0,0,1,201.52,41.2Zm0-23.7A11.48,11.48,0,1,0,213,29,11.49,11.49,0,0,0,201.52,17.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Like--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.39,27.65s1.25-3,1.33-3.5a14.22,14.22,0,0,0-.55-2.66c-.07-.35,1.53-.81,2.3.32a5.12,5.12,0,0,1,1,3.38l4-.82a1.25,1.25,0,0,1,1.44,1,1.36,1.36,0,0,1-.4,1.29,1.13,1.13,0,0,1,1,.95,1.26,1.26,0,0,1-.71,1.4,1.55,1.55,0,0,1,.45.9,1.41,1.41,0,0,1-.87,1.39,2.54,2.54,0,0,1,.36.86,1.42,1.42,0,0,1-1.21,1.55l-6.56,1.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.4,
    y: 27.83,
    width: 2.92,
    height: 8.82,
    transform: "translate(-2.44 40.69) rotate(-11.73)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.36,311.92a16.13,16.13,0,1,1,16.12-16.12A16.14,16.14,0,0,1,88.36,311.92Zm0-31.5a15.38,15.38,0,1,0,15.37,15.38A15.4,15.4,0,0,0,88.36,280.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.52 289.13 78.19 289.13 88.36 296.2 98.52 289.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.68 301.51 99.68 290.1 92.87 294.94 91.61 295.84 88.36 298.15 85.05 295.8 78.25 302.46 98.46 302.46 91.8 296.02 93.04 295.11 99.68 301.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.79 294.9 77.02 290.1 77.02 301.53 83.67 295.1 84.86 295.98 85.05 295.8 83.79 294.9 83.79 294.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.44,340.06a10.62,10.62,0,1,1,10.61-10.61A10.62,10.62,0,0,1,468.44,340.06Zm0-20.48a9.87,9.87,0,1,0,9.86,9.87A9.88,9.88,0,0,0,468.44,319.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.63,333.13a2.2,2.2,0,1,1-2.19-2.2A2.2,2.2,0,0,1,470.63,333.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.43,327.33a5.81,5.81,0,0,0-5.11,3.07.87.87,0,0,0,.23,1.09h0a.85.85,0,0,0,1.28-.26,4.06,4.06,0,0,1,7.19,0,.85.85,0,0,0,1.28.26h0a.87.87,0,0,0,.23-1.09A5.81,5.81,0,0,0,468.43,327.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.43,323.81a9.3,9.3,0,0,0-7.84,4.32.86.86,0,0,0,.18,1.16h0a.86.86,0,0,0,1.26-.22,7.58,7.58,0,0,1,12.81,0,.86.86,0,0,0,1.26.23h0a.88.88,0,0,0,.19-1.17A9.32,9.32,0,0,0,468.43,323.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,482.55a10.94,10.94,0,1,1,10.94-10.94A11,11,0,0,1,250,482.55Zm0-21.13a10.19,10.19,0,1,0,10.19,10.19A10.2,10.2,0,0,0,250,461.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250 464.41 252.12 468.7 256.85 469.38 253.43 472.72 254.23 477.44 250 475.21 245.77 477.44 246.57 472.72 243.15 469.38 247.88 468.7 250 464.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.05,
    y: 47.2,
    width: 53.44,
    height: 0.75,
    transform: "translate(-1.18 90.77) rotate(-30.18)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.45,
    y: 30.27,
    width: 0.75,
    height: 40.86,
    transform: "translate(20.14 156.64) rotate(-40.07)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.88,
    y: 74.84,
    width: 59.38,
    height: 0.75,
    transform: "translate(-6.33 32.09) rotate(-6.13)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.45,
    y: 152.42,
    width: 0.75,
    height: 38.13,
    transform: "translate(-8.3 2.44) rotate(-2.79)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.89 153.37 377.55 117.66 378.26 117.41 390.6 153.13 389.89 153.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.18,
    y: 185.28,
    width: 73.56,
    height: 0.75,
    transform: "translate(235.04 630.92) rotate(-84.31)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.16,
    y: 80.25,
    width: 0.75,
    height: 58.19,
    transform: "translate(116.76 420.78) rotate(-60.03)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.9 161.31 405.62 160.61 450.91 142.66 451.19 143.36 405.9 161.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.38 314.75 417.78 314.31 434.45 291.49 435.05 291.93 418.38 314.75",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.83 375.99 423.31 375.45 461.86 337.24 462.38 337.77 423.83 375.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.74 465.55 205.55 423.75 206.12 423.27 241.32 465.07 240.74 465.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.29,
    y: 445.26,
    width: 48.22,
    height: 0.75,
    transform: "translate(-248.68 410) rotate(-54.65)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.21,
    y: 409.12,
    width: 62.82,
    height: 0.75,
    transform: "translate(-68.91 68.31) rotate(-10.49)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.48,
    y: 261.58,
    width: 0.75,
    height: 65.29,
    transform: "translate(-5.52 0.74) rotate(-1.08)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.98,
    y: 311.04,
    width: 0.75,
    height: 65.2,
    transform: "translate(-59.34 22.5) rotate(-10.2)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.11,
    y: 114.05,
    width: 33.16,
    height: 0.75,
    transform: "translate(-47.34 49.92) rotate(-29.64)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.6,447.3a38.78,38.78,0,1,1,38.77-38.77A38.82,38.82,0,0,1,405.6,447.3Zm0-76.8a38,38,0,1,0,38,38A38.07,38.07,0,0,0,405.6,370.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.66,449.85a38.78,38.78,0,1,1,38.78-38.78A38.81,38.81,0,0,1,91.66,449.85Zm0-76.8a38,38,0,1,0,38,38A38.07,38.07,0,0,0,91.66,373.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.59,295.74A38.78,38.78,0,1,1,487.37,257,38.82,38.82,0,0,1,448.59,295.74Zm0-76.8a38,38,0,1,0,38,38A38.07,38.07,0,0,0,448.59,218.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.83,266.36A38.78,38.78,0,1,1,90.6,227.59,38.81,38.81,0,0,1,51.83,266.36Zm0-76.8a38,38,0,1,0,38,38A38.07,38.07,0,0,0,51.83,189.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.55,122.67a38.78,38.78,0,1,1,38.78-38.78A38.83,38.83,0,0,1,361.55,122.67Zm0-76.81a38,38,0,1,0,38,38A38.07,38.07,0,0,0,361.55,45.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.09,122.67a38.78,38.78,0,1,1,38.78-38.78A38.82,38.82,0,0,1,115.09,122.67Zm0-76.81a38,38,0,1,0,38,38A38.07,38.07,0,0,0,115.09,45.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Line--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.86,454.43a204.45,204.45,0,0,1-152-341.11c75.38-83.9,205-90.83,288.85-15.46A204.46,204.46,0,0,1,249.86,454.43Zm.26-407.85A203.26,203.26,0,1,0,386,98.62,203,203,0,0,0,250.12,46.58Z",
    style: {
      fill: "#51A2E5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--World--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--world--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.35,353.15a138.64,138.64,0,1,0-44.93-120.36A138.64,138.64,0,0,0,157.35,353.15Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.35,353.15a138.64,138.64,0,1,0-44.93-120.36A138.64,138.64,0,0,0,157.35,353.15Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.91,174.17a4,4,0,0,0,2.62.13,6.86,6.86,0,0,0,1.38-.65c.54-.31,1.67-1.56,2.09-1.49s.06,1.56-.3,2.43a12.69,12.69,0,0,1-2.56,3.7c-1.65,1.58-2.73,2-4,2.07-.45,0-2.31,0-2.84.84s-.26,1.12.13,1.27a4.59,4.59,0,0,0,2-.13,1.39,1.39,0,0,1,.86,0c.78.35-.14,2.56.52,3.06.4.3,1.13,0,1.69-.19a11.52,11.52,0,0,0,2.53-.8,7.52,7.52,0,0,0,1.44-1.05,30.9,30.9,0,0,1,3.66-2.29,2.25,2.25,0,0,0,1.28-2.69c-.24-1-1.08-.74-2-.18-1.28.75-2.7,1.85-3.08,2s-.58.21-.5-.11c.14-.62,1.67-1.56,1.95-1.77.59-.45,1.18-.93,1.76-1.38,1-.76,2.11-1.49,2.58-1.83a6.88,6.88,0,0,0,.86-.71,6.2,6.2,0,0,0,1.1-1.4c.5-1.12-.18-1.44.3-2.45a7.54,7.54,0,0,1,1.64-1.94,22.07,22.07,0,0,0,1.78-1.92c1-1.4.62-2.64,1.22-4.17a8.89,8.89,0,0,1,1.42-2.34c.83-1,2-2.24,2.62-3,.38-.48.74-1,1.11-1.43a9.65,9.65,0,0,0,1.15-1.9c.21-.45.37-1,.56-1.4a3.26,3.26,0,0,1,.74-1,6.74,6.74,0,0,0,1.82-3.41c.28-1.67-.77-1-1.1-1.24-.57-.42-1.27-.16-2,.17-1.67.75-3.54,2.17-5.46,3.27q-3.54,3.42-6.88,7.12c-1.9,2.13-3.71,4.31-5.47,6.51A4,4,0,0,0,143,164c1.28,0,2.93-1.8,4.38-2.73.64-.41,2.55-1.94,2.85-1.32.47,1-1.62,2.83-2.07,3.21a3.1,3.1,0,0,0-.93,1.13c-.39.94-1.11,2.25-1.87,2a3.24,3.24,0,0,0-1.41-.38.88.88,0,0,0-.79.71c-.27.85-1.32,2.39-1.76,1.6-.27-.46-.41-1.17-.86-1.28s-.82.05-1.16-.08l-.18-.11c-1.72,2.29-3.37,4.61-4.93,7A2.66,2.66,0,0,0,134.91,174.17Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.08,138.55a17.2,17.2,0,0,1,3.26-3.66c.59-.5,1.21-1,1.85-1.44.39-.28.78-.55,1.18-.81a7.8,7.8,0,0,0,1-.52,1.09,1.09,0,0,0-.53-1.82,1.89,1.89,0,0,0-.46-.11,1.35,1.35,0,0,0-1,.4,9.51,9.51,0,0,1-2.63,1.38c-3.91,1.39-6.77,3.67-7.17,7.62a20.38,20.38,0,0,0-.2,4.2c.1.51.19,1-.31,1.23-.32.14-.44.29-.2.7a5.1,5.1,0,0,0,2.93,1.88,18.73,18.73,0,0,0,2,.65,2.46,2.46,0,0,0,2.36-.65c.31-.46-.45-1.19-.93-1.74l-.57-.6a6.76,6.76,0,0,1-1.19-2.23,5.76,5.76,0,0,1-.22-1.53A5.94,5.94,0,0,1,280.08,138.55Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,138c.44.26.87.67,1.31,1a6.88,6.88,0,0,0,1.62.79,15.71,15.71,0,0,1,1.94.77,1.27,1.27,0,0,1,.25.21c.28.31.12.26.17.53.09.49.47.69,1,.82s.91.31,1.38.48c.77.28,2.05.15,2.08-.58a5.66,5.66,0,0,0-.22-1.44,10.19,10.19,0,0,1-.51-2.37,3,3,0,0,0,0-.34c0-.19.34-.53,1-.37.45.11.94.28,1.2.34s.36.07.47.11c.26.09.35.45.38.58a.32.32,0,0,0,.15.21,1,1,0,0,0,.53.18,5.89,5.89,0,0,0,1.83.18,2.13,2.13,0,0,0,.66-.2.68.68,0,0,0-.15-1.17,20,20,0,0,1-2.82-.66,6.45,6.45,0,0,1-1.74-1.09c-1-.89-.26-1.31.4-1.48a8.69,8.69,0,0,0,1.53-.55,3.44,3.44,0,0,0,1.71-1.66,1.61,1.61,0,0,0-.38-1.21l-.11-.08a2.29,2.29,0,0,0-2.26-.09c-.82.28-1.73.55-2.6.76a5.49,5.49,0,0,1-1.18.27,3.07,3.07,0,0,0-.92.07,3.71,3.71,0,0,0-1.3,1,2.89,2.89,0,0,1-1.61.95c-.36.07-1,0-.93.48.12.67,1.1,1.06,1.41,1.65s-.37.41-.82.13-.59-.86-1-1.12-.6-.05-.61.16c0,.37.21.86-.55.59-.42-.15-.67-.43-1.11-.45-.75,0-2.16.87-1.23,1.94A3.6,3.6,0,0,0,218,138Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.27,199.12c-.94-.89-2.65-1-2.85-2.71-.07-.55.47-1.2.12-1.75-.19-.3-.54-.27-.81-.36s-1.56-.75-1.58-1.24c0-.32-2.71.12-2.22,1,.72,1.26-1.35,2.27-.12,2.86l.15.08c.09,0,0,.86.36,1.79s1.76.95,2.06,1.74,1.43-.18,2.05.44,1,2.17.35,2.66.06,2-.34,2.48c-.26.32-.54.63-.1,1.09.26.27,1-.57,1.23.19s-.74,1.08-.28,1.67,1.1.12,1.5,0c1.69-.61,3.88-1.72,4.64-3.6.3-.72.82-2.45-.16-2.83-.37-.14-.77,0-1.16-.27a5.07,5.07,0,0,1-1.15-1.16A18.26,18.26,0,0,0,234.27,199.12Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.46,287.52c.7.43,2.2,2.15,2.93,1.92,1.28-.39-.92-2.59-1.32-2.9s-3.72-3.67-3.68-3.72a.51.51,0,0,0,.08-.55c-.08-.15-.9-.47-1.52-.9.38,1.66.8,3.3,1.24,4.95C116.89,286.81,117.93,287.2,118.46,287.52Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,303.77a46.09,46.09,0,0,0-.29-10.06c-.1-.64-.22-1.31-.38-2a6,6,0,0,0-1.1-2.43,5,5,0,0,1-.55-.46,4.63,4.63,0,0,1-.37-.46,2.21,2.21,0,0,0-.47-.49c-.29-.21-1.09.39-1.06,1.35,0,.61.16,1.29.21,1.74.32,2.45-1.32,4.06-2,6.08-1,2.82.14,5.25.71,7.82.37,1.67.14,4.12,1.1,5.44C324,314.64,324.86,306.34,325,303.77Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.09,257.05a1.7,1.7,0,0,0-1.45-.56,22,22,0,0,0-3.38.88,4.4,4.4,0,0,1-1.89.17,1.86,1.86,0,0,1-.95-.45c-.64-.58-.67-1.6-.82-2.59a3.71,3.71,0,0,0-1.48-2.52c-.32-.28-.64-.59-1-.85-.52-.42-1.14-.52-1.65-1a3.11,3.11,0,0,1-1.16-1.76,2,2,0,0,1,.24-1.25,3.49,3.49,0,0,0-.21-2.65c-.28-.47-.6-.89-.82-1.22a16.33,16.33,0,0,0-1.36-1.7c-.23-.27-.53-.4-.76-.67A14.78,14.78,0,0,1,367,234c-.1-.76,0-1.56.61-1.69a1.06,1.06,0,0,1,.6.08,6.08,6.08,0,0,1,1.45,1c.4.35.8.69.9.65,1.26-.43,2.51,4.23,3.72,1.88.37-.73,1-1.26,1.43-2a8,8,0,0,0,.45-.93,7.19,7.19,0,0,0,.45-2.83,6,6,0,0,0-.42-1.76,12.69,12.69,0,0,0-3.72-4.47c-.57-.36-.92-.51-1.16-1.32-.5-1.74.48-4.11,2.13-4a2.49,2.49,0,0,0,2.61-1.22,11.86,11.86,0,0,1,2.36-3.25c1.35-1.07,3.2-2.27,4.06-3.88.07-.15.15-.29.23-.45a137.38,137.38,0,0,0-6-16.19c-.25-.57-.67-1.49-1-2.28a139.12,139.12,0,0,0-57-61.92,8.09,8.09,0,0,1-.83.27,20.29,20.29,0,0,0-3.82,1.23,3.54,3.54,0,0,0-1.66,2.58,3.32,3.32,0,0,1-.72,1.75,3.59,3.59,0,0,1-2,.92c-.54.13-1.61.34-1.18,1.19s2.09,1.64,2.77,2.32c1.54,1.54-1.33.68-2.06.46a7.14,7.14,0,0,0-2.48-.42c-.46,0-1.53,0-1.43.53s.81,1.11,1.18,1.49c.54.58.66.8.2,1.07s-1,.5-1.5.77a5.25,5.25,0,0,1-2.62.77c-1.26-.06-2.41-1.09-3.31-2.17a3.74,3.74,0,0,0-1.55-1.37,3.35,3.35,0,0,0-1.78-.35c-1.17.18-1.06,1.31-.54,2.4s-.45,1.67.15,2.66a7.49,7.49,0,0,0,2.75,2.22c.84.5,2.25,1.15,2.14,2-.15,1.24-1.91.75-3.15.34-1.67-.56-3.32-.89-5-1.46a9.37,9.37,0,0,0-4.3-.35c-.74.11-1.09.6,0,1.28.49.32,2,.73,2.09,1.5s-1.63,1-2.14,1.16a18.65,18.65,0,0,1-4.41,1.28c-1.2.13-2.55-.05-3.55.44a6.07,6.07,0,0,0-1.31.85,3.63,3.63,0,0,0-.92,1.92.73.73,0,0,1-.3.48,2.11,2.11,0,0,1-.53.31,1.78,1.78,0,0,1-2-1.07c-.2-.67-.38-1.41-1.08-1.65a2.91,2.91,0,0,0-2.33.38.91.91,0,0,0-.26.81c.05.55.74,1.92.88,3a2.3,2.3,0,0,1-.27,1.64,6.22,6.22,0,0,1-1,.88,2.7,2.7,0,0,0-.8,1.67c-.25,1.25-.42,2.38-1.5,2.93s-2.05.31-3.47-.63a28.32,28.32,0,0,1-3-2.11c-1.39-1.22.94-1.05,1.55-1.07.9,0,1.72-.3,2.6-.4a8.54,8.54,0,0,0,2.11-.48c.53-.2,1.48-.58,1.16-1.47-.69-1.95-5.21-3.11-6.53-3.5-.64-.19-1.28-.35-1.91-.5-1-.25-2.82-.64-4-.86a5.47,5.47,0,0,0-2-.12c-1,.21-1.36,1.66-2.92.06a3,3,0,0,0-2.5-1.23,9.57,9.57,0,0,0-5.39,1.75,5.11,5.11,0,0,0-1.11,1.16c-.52.73-.92,2-1.37,2.42a1.84,1.84,0,0,1-1,.48c-2.34.39-2.58,2.64-2.06,5.46.14.75.41,1.58.48,2.33a4.83,4.83,0,0,1-.07,1.27c-.12.67-.44,2.21-.65,3.48-.13.76-.28,1.54-.42,2.35-.37,2.26-.87,4.6-1.39,7a8.32,8.32,0,0,0,.24,5.33,5.32,5.32,0,0,0,3.07,2.56,3.6,3.6,0,0,0,3.68-.77c1.54-1.1,2.52-.44,3.92,1.4.6.8,1.24,1.8,2.15,2.14a3.2,3.2,0,0,0,2.71-.29c.83-.59.87-1.68.42-2.84a3.49,3.49,0,0,1-.12-2.95,2.83,2.83,0,0,0-.56-2.77c-1-1.44-2.69-3.13-3.22-4.11a4.79,4.79,0,0,1-.57-1.82,8.26,8.26,0,0,1,0-1.58c.1-.81.81-2.44,1.24-3.9a8.78,8.78,0,0,0,.37-2.89,4.46,4.46,0,0,1,.1-1.36,1.87,1.87,0,0,1,1.83-1,1.78,1.78,0,0,1,1.3.64,4.07,4.07,0,0,1,.53,3c-.17,1.08-.94,1.53-1.19,2.53s.24,2.49.66,3.72.79,2.73,1.73,3.54c1.17,1,2.69.24,3.72-.15.46-.17,1-.37,1.53-.52a5.65,5.65,0,0,1,2.39-.18c.42.12,1.08,1,.77,1.35a2.18,2.18,0,0,1-.7.39c-1,.44-2.14.63-3.16,1-.65.25-1.73.5-1.54,1.57.15.82,1.1,1.26,1.66,1.63s1.21.79,1.28,1.53a.65.65,0,0,1-.6.73,3.19,3.19,0,0,1-1.73-.56c-.35-.21-.87-.66-1.16-.38-.47.45.43,2.34.64,2.95a5.66,5.66,0,0,1,.43,3.26c-.61,2.09-2.91,2.69-4.72,3.14a19.67,19.67,0,0,1-3.45.31,6,6,0,0,1-2.27-.1c-1.76-.64-1.76-3.59-2.55-5.11-.93-1.8-2.15,0-2.11,1.21.06,1.91,2.09,3.58,2,5.42-.06,1.28-1.45,1.72-2.25,2.34a4,4,0,0,0-1.1,3.9,3.57,3.57,0,0,1-.6,2.14c-.41.9-.94,1.7-1.39,2.54a2.57,2.57,0,0,1-1.49,1.37c-.44.13-1.17,0-1.4.38s.16,1-.42,1.48-1.61.42-2.32.74c-.47.21-1.1.77-.43,1.26a7.71,7.71,0,0,0,2.31.64,4.54,4.54,0,0,1,2.72,3c.77,1.94.75,3.67-1.06,4.39s-3.69.85-5.29,2.23c-1.39,1.21-.43,4.29.09,6A3.5,3.5,0,0,0,234,232c.44.42.76,1.05,1.28,1.33a2.69,2.69,0,0,0,2.12,0,2.48,2.48,0,0,1,2.15.14,2.92,2.92,0,0,0,.51.2c.29.06.45-.74.94-1a3.85,3.85,0,0,1,1-.26,3.36,3.36,0,0,0,1-.22c.29-.17.33-.52.53-.67a3.22,3.22,0,0,0,.93-2.7c0-.51,0-1,0-1.53a16.18,16.18,0,0,1,.35-1.71,8.55,8.55,0,0,1,.1-1.25c.24-.81.88-.87,1.45-1.27a2.12,2.12,0,0,0,.87-2.21c-.08-.76-.36-1.58.23-2.08s1.25-.17,1.83-.32c1-.26,1.59-1.19,2.28-1.9,1.39-1.42,2.89-1.28,4.45.18a15.35,15.35,0,0,0,2.22,1.82c.62.38,1.29.51,1.91.9.77.49,1.64.78,2.38,1.25.89.56,1.11,1.86,1.18,2.85,0,.4-.1,1.07.27,1.33s.69-.21.83-.52c.48-1,.07-1.9-.27-3-.15-.5-.4-1.09,0-1.36.15-.11.4-.06.62-.06s0-1.06-.86-1.39a2.83,2.83,0,0,0-1.49-.22c-.36.07-1.62-.9-2-1.11a21.5,21.5,0,0,1-2.68-1.74,4.55,4.55,0,0,1-1.64-1.95c-.36-1.24.89-1.5,1.72-1.16.67.28.93,1,1.44,1.5,1.11,1.17,2.61,1,3.88,1.43.9.29,1.09,1,1.67,1.77a12.1,12.1,0,0,1,1.38,1.8c.25.5.24.58.68.88a9,9,0,0,0,1.3.68,5.42,5.42,0,0,1,1.24.54c.4.31.27.31.33.74.13.94.37,1.86,1.33,2.11s.66-1.43.78-2.18a1.74,1.74,0,0,0-.18-1.51c-.3-.43-.88-.59-1.22-1-.84-1,.28-1.24.7-1.79s1-1.74,2.13-1.32c.65.25.66.68.79,1.3a5.74,5.74,0,0,0,1,1.8,8.06,8.06,0,0,0,1,1.77A4.88,4.88,0,0,0,280.7,222c.59-.17,1-.81,1.64-.84.27,0,.5.16.77.2a3.11,3.11,0,0,0,1.35-.24c.58-.21,1.08-.58,1.68-.75,1-.29,1.32-.1,1.41,1.09a42.85,42.85,0,0,0,.59,5.36c.13.66.78,2.21.52,2.79s-1.56,0-2.1-.13a9.15,9.15,0,0,0-4.62.57,17.29,17.29,0,0,1-2.31.75,4.39,4.39,0,0,1-2.3.2c-1.39-.56-5-2.25-5.68,0-.43,1.52.71,3.81-1.37,4a9.49,9.49,0,0,1-2.95-.55,21.46,21.46,0,0,0-4.42-.45,5.11,5.11,0,0,1-3-.8c-1.27-.9.12-1.72-.06-2.94a3.37,3.37,0,0,0-1.83-2.57,4,4,0,0,0-2.53.29c-.42.14-.83.14-1.25.26A5.86,5.86,0,0,0,253,229a13.42,13.42,0,0,1-2.87,1.17c-.53.17-1.05.33-1.56.51-.3.11-1.13.25-1.31.55-1,1.57-2.23,3.33-4.08,3.74-1.16.25-2.22.17-3.22,1a11.26,11.26,0,0,0-2.32,3c-.54.91-1,1.86-1.5,2.82-.56,1.12-.17,2.27.21,3.51a3.32,3.32,0,0,1,0,2.22,7.65,7.65,0,0,1-1.85,3.2,7.14,7.14,0,0,0-2.18,3.38,21.29,21.29,0,0,0-.52,3.94,11.29,11.29,0,0,0,2.62,7.56c.5.54.25,2.74.32,3.46a6.56,6.56,0,0,0,1.29,3.67,6.26,6.26,0,0,0,2,1.72c1.56.83,2.77,2.31,4.23,3.46a25.9,25.9,0,0,0,4.37,2.87,9.52,9.52,0,0,0,6.15,1,5.69,5.69,0,0,0,2.71-1.26,4,4,0,0,1,1.39-.82,9.27,9.27,0,0,0,2.9-1.71c.43-.45.85-.94,1.23-1.37a3.61,3.61,0,0,1,3.17-1.46,5,5,0,0,1,1.57.47,14,14,0,0,0,3.07,1.11,4.05,4.05,0,0,0,1.5-.09,3.75,3.75,0,0,1,2.51.36c2.11,1.13,1.86,3.57,1.49,5.74-.34,2,.91,3.59,2.12,4.8.59.58,1.07,1.2,1.65,1.74a7.36,7.36,0,0,1,1.76,2c.38.76.8,1.43,1.19,2.13a18.22,18.22,0,0,1,1.6,4.62c.14.79.25,1.6.32,2.41,0,.39.07.79.1,1.19a13.52,13.52,0,0,1,0,2.21,6.32,6.32,0,0,0-.09,1,12.71,12.71,0,0,0,.3,2.44c.28,1.33.71,3.68,1,5a11.64,11.64,0,0,0,.74,2.32,59.82,59.82,0,0,0,5.6,9c.95,1.37,1.84,2.83,2.77,4.19.47.69.88,1.47,1.4,2.13a11.44,11.44,0,0,1,1.22,2.42c.83,1.68,1.72,2.59,3.24,2.59a6.52,6.52,0,0,0,3.46-1.52,15.51,15.51,0,0,0,5.36-6.48,19.75,19.75,0,0,0,1.36-5.64,11.7,11.7,0,0,0,.16-2.73c-.07-1-.25-1.95-.26-2.94,0-1.5-.12-3.11-.05-4.6.1-2.34-.1-4.28.94-6.34a29.67,29.67,0,0,1,1.65-2.68c.91-1.42,2.64-3.82,2.07-6-2.71-10.48-8-17.7-.92-28.05,1.7-3.48,3.61-9,3.31-13.54-.15-2.16-1.86-3-3-2.17a20.12,20.12,0,0,1-2.1,1.5c-.67.41-1.4.72-2.08,1.08a3.8,3.8,0,0,1-2.27.11,2.23,2.23,0,0,1-1.79-1.12c-.5-.71-.62-1.54-1-2.27a3.91,3.91,0,0,0-1.78-1.33,15,15,0,0,1-3.91-3.11,18.13,18.13,0,0,1-2.63-4.46A8.35,8.35,0,0,0,293.5,240a22.7,22.7,0,0,1-2.4-2.56c-.74-.92-3.4-4-2.19-5.21,1-.91,2.76,2.1,3.41,2.84,1.27,1.49,2.57,2.8,3.87,4.08l2,2c1.12,1.09,2.47,2.44,3,3,.33.33.65.68,1,1a10.35,10.35,0,0,1,1.8,2c1.44,3.14,2.94,4.63,4.72,4,1.63-.59,3.55-3,4.82-4.32a52.3,52.3,0,0,0,6.15-7.4,11.4,11.4,0,0,0,.89-2.66,8.8,8.8,0,0,0,.58-3.15,1.86,1.86,0,0,0-1.35-1.86c-.55-.15-1,.2-1.53,0s-.93-1.12-1.45-1.54c-1-.81-1.56.14-2.21.82s-2,2.18-2.95,1.76c-.68-.3-.54-.93-1-1.42s-.69-.12-1.13-.13c-1.12,0-2-1.41-2.75-2.25-.58-.64-1.89-2.07-1.88-3.06,0-1.66,2.19-.08,2.81.32a25.92,25.92,0,0,1,2.31,1.3,3.6,3.6,0,0,0,1.95.74,12.51,12.51,0,0,0,2.14.3c.53,0,1-.38,1.55-.34a1.89,1.89,0,0,1,.93.32,5.22,5.22,0,0,0,3.85.67c1.43-.41,2.8-1.18,4.1-1.68a6.53,6.53,0,0,1,3.24-.62,6.16,6.16,0,0,1,3.57,2c.71.89,1.48,2.21,2.65,2.43s1.13-2.36,1.89-2c.41.22.65,1.18.81,1.6a14.69,14.69,0,0,0,.72,1.56c.6,1.17,1.19,2.36,1.8,3.56a64.85,64.85,0,0,0,4.06,7.16c.74,1.07,1.84,2.7,3,2.79.52,0,1.09-.84,1.28-1.4a6,6,0,0,0,.17-1.8,18.16,18.16,0,0,0-.12-2.34,26.74,26.74,0,0,1-.11-4.34,14.81,14.81,0,0,1,.36-1.92,15.32,15.32,0,0,1,1.22-3.33,12.92,12.92,0,0,0,1.26-2.32c.11-.36.22-.72.32-1.09a20.13,20.13,0,0,1,.74-2.07,2.11,2.11,0,0,1,.57-.84,5.32,5.32,0,0,1,1-.44c.68-.33.74-1,1.25-1.5s1.23-.17,1.73.15c1.41.93,2,2.9,2.62,4.51.31.8.67,1.83,1.48,1.7s1.15-.76,1.95-.28,1.26,1.82,1.89,2.66,1.46,1,1.86,2c.26.64,0,.83-.1,1.41s.12.91.43,1.4a3.35,3.35,0,0,1,.56,1.79,5.37,5.37,0,0,0,.05,1.79.8.8,0,0,0,.75.56,2.41,2.41,0,0,1,1.49,1.17c.2.38.38.79.53,1.07a6.09,6.09,0,0,0,.7,1.24c.11.13.21.21.31.31a3.17,3.17,0,0,1,.62,1.4,1.07,1.07,0,0,1-.2,1c-.21.18-.56.11-.92,0s-1.29-.51-1.76-.63a1.84,1.84,0,0,0-.83-.08c-1.41.28,1,3.14,1.49,3.57s.83.6,1.23,1a4.14,4.14,0,0,1,.88,1.38,17.75,17.75,0,0,0,2.15,2.87,13.44,13.44,0,0,0,2.33,2.32,6.4,6.4,0,0,0,1.31.75c.13.06,1.34.31,1.35.36.88,4,3.53.65,5.25,1.48,1.38.8,2.62,0,3.91-.46a6.07,6.07,0,0,0,1-.48c0-.36,0-.73.05-1.1A1.61,1.61,0,0,1,387.09,257.05ZM288.3,211.3a14.56,14.56,0,0,1-3.8,0c-1.8-.09-4.23,1.24-5.75,2a5.29,5.29,0,0,1-2.4.73c-1.78,0-1.84-4-1.65-6a7.77,7.77,0,0,1,.68-3c.91-1.55,3.92-.68,3.62-.11s.44.87.68,1.32.82.76,1.16.2-.8-2.52.45-3.72a5.21,5.21,0,0,1,.5-.41c1.36-1.06,2.37-.42,2.69,1.62a4.11,4.11,0,0,0,.44,1.4c1.05,1.85,3.12,1.54,3.19,1.76s.91.28,1.72.83S290,210.92,288.3,211.3Zm19.38,1.06c.1,1.58-1.55,2.39-3.46,2s-2.79-3.08-3.27-4.85-3.75-2.67-4.62-4.59c-1.55-3.4.67-7,2.91-7.38,1.73-.33,1.29,2.48.93,4.35-.12.65.3,1.09,1.07,1.69,1.6,1.24,3.29,1.54,4.22,2.06s.28,1.65-.54,2.19S307.54,210.35,307.68,212.36Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.55,340c.25-1.32,1.76-3,2.95-3.89.93-.73,1.62-.95,2-2.44a9.24,9.24,0,0,0-.65-5.19c-.52-1.05-.34-2.28-.71-3a18.2,18.2,0,0,1-2.2-5.06c-.63-3.34,1.72-6.17,1.16-9.69-.35-2.2-3.11-3.65-4.85-3.95s-4.24-2.56-6-2.05l-.56.16c-1.75.5-5-1.09-6.9-1.28a9.74,9.74,0,0,0-1.32,0c-1.88,0-4.5-1.52-6-3.27s-2.88-3.1-4.52-3.51c-2.21-.53-4.36,1.74-6.56.12a8.94,8.94,0,0,0-3.08-1.61,9.59,9.59,0,0,1-3.21-1.36c-1.44-1.08-2.06.2-3.43,0-.8-.13-1.15-.44-2-.21-1.07.29-2.12.7-3.2.88-.89.14-1.33-.22-2.17-.57-1.93-.8-4.22.8-4.85,2.44-.31.81-.21,1.89-.53,2.64-.65,1.5-3.14,1.09-4.65.74a8.26,8.26,0,0,1-3.25-1.56c-1.14-.94-1.85-1.07-2.21-2.58-.27-1.08-.43-2.54-1.46-3.27a3.51,3.51,0,0,0-2.78-.23c-.7.15-1.52.69-2.29.49a2.59,2.59,0,0,1-1.69-2c0-.61.52-1.11.68-1.65a2.26,2.26,0,0,0,.12-.94c0-.16-.37-.78-.35-.83.31-1.35-.15-2-.89-2.07-1.32-.18-3,1.45-2.89,3s-2,3.23-3.77,3c-3.39-.52-6.38-5.82-6.46-9.93,0-1.88,1.21-4.82,2.73-5.45,1.23-.52,2.73-.36,4.22-.63.63-.06.5-.48.37-.9-.2-.69,1.17-1,2.15-1.34a5.32,5.32,0,0,1,4.74.75,12.38,12.38,0,0,1,1.73,2.12c1.13,1.57,3.76,2,2.79.19-.61-1.11-1.61-2.45-2.33-3.72-1-1.74-.22-4.61.72-5.92a24.61,24.61,0,0,0,1.68-2.4,4.34,4.34,0,0,0,.71-2.56c-.2-1-1.14-1.8-1.36-2.94a5.78,5.78,0,0,1,0-2.38,7.28,7.28,0,0,1,1.78-3.43c.82-.82,2.57-1.1,2.76-2.6s0-2.34.77-3.71a10.31,10.31,0,0,1,1.86-2.22c1.14-1.07,1.06,1.49,2.63.86a13.79,13.79,0,0,0,4-3.47c1.23-1.46,1.42-3.41.79-3.86s-1.19,3-2.83,3.05a3,3,0,0,1-.52,0c-1.62-.32-2-2.84-2.26-2.72s-.35-.3,0-.56.14-3-1.27-2c-.24.18-.49.39-.74.62-1.33,1.21-1.83,0-.51-1.21,2.1-2,4.92-3,7.47-4.38,1.54-.85,2.34-.13,1.85,1.93s-.69,3.39.57,3.31c1.69-.09,3.43-1.34,3.62-.71.12.41.25.78.69.23.66-.82,1.89.33,2.33-.89a1.81,1.81,0,0,0-.59-1.73c-.66-.75-1.6-2.16-2.58-1.94s-1.8-2.19-1.76-4.34c0-.22,0-.45,0-.66-.05-2.14-2.9-3.12-4.37-3.88-4.35-2.24-3-2.77-5.8-6.76-1-1.47-2.4-.83-3.37.93-.52.94-1.1,1.67-1.66,1.74-1.46.17-1.55-4.34-2.59-4.53-.57-.11-1.28,0-1.75-.81-.79-1.42-2.41-1.57-3.81-.91s-2.2,3.52-1.78,5-.43,4.19.31,5.14,2,3.5,1.28,5.39c-.46,1.13-1.26,2.12-1.61,3.24-.61,2,1.25,4.36.82,5.5a1.14,1.14,0,0,1-1.38.85,4.32,4.32,0,0,1-2.5-2.25c-.82-2.33-.21-4-2.36-4a21.41,21.41,0,0,1-8.26-1.61c-1.21-.54-1.3-1.63-1.86-2.93s-1.82-1.4-.67-3.69c.72-1.44,2-2.66,2.27-4.6s-1.36-1.61-.63-3.27,3.2-1.69,4.2-2.46a2.5,2.5,0,0,0,1.13-1.57c.25-1.36-.72-1.18-1.05-1.74-.11-.18.23-.39.58-.55a3.78,3.78,0,0,0,1.34-.76,2.43,2.43,0,0,0,.5-.91,6.2,6.2,0,0,1,.22-1,1.74,1.74,0,0,1,.72-.73,4.8,4.8,0,0,0,1.74-1.19,7,7,0,0,0,1.88-3.07,5.73,5.73,0,0,0,.06-2.46c-.21-.39-.73-.21-.82-.89-.3-2.24,2-2.85,2.78-3.2,1.11-.54,2.43-1.22,2.5,1.06,0,1,.26,3.41,1.24,1.81.56-.9.76-1.32,1.33-.76a2.05,2.05,0,0,1,.94,1.82,2.75,2.75,0,0,1-.87,2c-.71.79-1,4.16-2.3,4.74-.21.09-.43.18-.63.28-1.3.63-.61,3.82.6,2.87s2.93-.45,4.08.44c1.61,1.26,3.91,2.49,4.87,2.25,1.43-.37-.13-3.28.52-3.71a3.91,3.91,0,0,1,1.19-.63c.24-.05,0-1.94-.06-2.13a2.85,2.85,0,0,0-.85-1.37c-.76-.62-1.68-.48-2.25-1.63-.63-1.3.49-2.86,1.32-2.56.4.15.71.65,1,1.15.51.79,1.35,1.1,1.65.86a2.09,2.09,0,0,0,.49-.61c.33-.66.18-1.33.41-2,.39-1.06,1.25-1,1.63-2a1.2,1.2,0,0,0-.71-1.73c-1.25-.56-2.56-.75-3.75-1.25-.25-.11-.48-.15-.69-.27-.37-.2-.66-1.26-.68-2.1a9.11,9.11,0,0,0-.12-1.44,2.16,2.16,0,0,0-1.09-1.27,7.06,7.06,0,0,0-1.52-.88c-.88-.35-2.71,0-3.54-.94s-1.52-2.2-2.46-1.9c-.11,0-.41.48-.55.58a1,1,0,0,1-.64.19c-.42,0-.73-.31-1.12-.41a2.44,2.44,0,0,0-2.47.79,9.31,9.31,0,0,1-1,.88,11,11,0,0,1-2,.87,9.84,9.84,0,0,0-2.44,2.55,8.13,8.13,0,0,0-1.13,2.13c-.38,1.23-.5,3.07.24,3.1s1.91-.65,2.77-.78,2.63-.63,2.29,1.42c-.26,1.54-1.89,1.49-1.74,3.23,0,.57.36,1,.17,1.76a7,7,0,0,1-.89,1.77,9.87,9.87,0,0,1-1,1.33c-.48.51-1.29.52-1.35-.32-.06-.68.47-1.34.49-2.06a.79.79,0,0,0-.72-.91,1.82,1.82,0,0,0-.62,0,1.79,1.79,0,0,1-1.19-.53,3.51,3.51,0,0,1-.47-.67c-.24-.42-.58-.79-.83-1.25a3.86,3.86,0,0,1,.08-2.94c.19-.29.42-.57.66-1a16.74,16.74,0,0,0,1.19-2.57c.72-1.91.66-3.57-.54-3.17s-2.79,2.28-3.23,4.49a21.47,21.47,0,0,1-.72,3.8c-.44,1.15-1.17,2.09-1.56,3.23a19.37,19.37,0,0,0-.36,3c-.21,1-.45.86-.93,1.33-1.08,1-.52,3.17-1.52,4.43a3.24,3.24,0,0,1-1.18.76,4.6,4.6,0,0,1-2.18.52c-.21,0-.5,0-.44-.51.09-.7.67-1,1-1.35a6.43,6.43,0,0,0,1.29-4.65c-.21-.73-.88-.54-1.32-.78a3,3,0,0,1-1.2-2.78c-1.35,3.44-2.56,6.93-3.63,10.44a.67.67,0,0,1,.67.29c.21.33.13.79,0,1.41a10,10,0,0,0-.23,1.17c-.09.64-.54,3.05-1.32,2.73a3.66,3.66,0,0,1-.57-.33,135.88,135.88,0,0,0-3.46,17.92,139.82,139.82,0,0,0,2.18,47.09,1.16,1.16,0,0,1,1.19.06c1.44.79,2.75,3.44,4.2,4.25,2.42,1.33,5.26,3,7,5.35,1.12,1.5,2.74,3.75,4.42,4.36,3.27,1.19,7,1.85,9.89,1s7.13,3.56,9.61,1.45c.3-.26,2.32,1.82,2.6,2.09a10.6,10.6,0,0,0,3.71,2.1,22.11,22.11,0,0,0,4.3.93c2.66.39,5.94,1.21,6.18,5.06.15,2.33-.39,4.68-.54,7s-.07,4.84,1.6,6.83,3.85,3.12,5.49,5,1.82,4.77,3.56,6.86c2.17,2.61,4.55,2.65,7.69,3.22a10.16,10.16,0,0,1,6.21,3.37A88.75,88.75,0,0,1,202,352.38c3.77,6,7.16,12.48,12.16,17.49a29.27,29.27,0,0,0,8.25,6.14c2,.95,3.8.66,3.22-2-.35-1.6-1.89-2.69-2.78-4s-.54-2.71-.87-4.22c-.27-1.25-1.77-2.93-1.1-4.13s2.12-.77,2.34-2.21c.28-1.83-1.71-2.24-2.27-3.51s1.69-1.75,2.15-3.08c.3-.84-.13-1.78,0-2.63.12-.69.45-.87.75-1.4a7.27,7.27,0,0,0,.57-3.4C224.37,343.57,222.2,341.84,222.55,340Zm-88.66-92.05c1.11-1.55,3-4.91,4.4-4.47a5.08,5.08,0,0,1,1.9,1.59c1.13,1.28,3.4,1.34,4.77,1.69s-.12,1.93-.06,3.19-.72,1.91-.83,1.22c-.06-.42-.15-.74-.69-.38-.75.51-.68-.15-.59-.88.13-1-2.21-1.34-2.39.68a12.89,12.89,0,0,0,0,1.65c.05,2-1.83,2.37-1.87.35,0-.25,0-.51,0-.77.08-2-1-4.2-2.52-3.71C134.28,248.64,132.71,249.59,133.89,247.92Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.52,187.6c.4.68,1.25-.17,1.38-.53s.82-2.46.21-3.16c-.3-.34-.72-.17-1.12.2-.41.76-.81,1.54-1.21,2.31A5.56,5.56,0,0,0,127.52,187.6Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.35,208.71c.8,1.19,2,0,2.73-.43a3.86,3.86,0,0,0,1.43-3,3.66,3.66,0,0,0-1-2.31c-.57-.58-1.9-1.51-2.49-.81-.24.28-.05.65-.23.92s-1,.31-1.37.51c-1.05.57.14,1.54.5,2.17a2.52,2.52,0,0,1,.29,1.44C225.23,207.7,225,208.26,225.35,208.71Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.75,221.92c.22-1.91-2.55-6.68-2.75-4.64a6,6,0,0,0,0,1.13C253.12,220.5,255.52,223.84,255.75,221.92Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.85,238.81c.42-1.39.14-3.05-1.21-2.91s-1.6,1.66-2.29,2.94a28.58,28.58,0,0,1-2.92,4.29c-.67.82-2.21.53-2.11,2.14a7.39,7.39,0,0,0,1.55,3.85,7.27,7.27,0,0,0,2,2.25c1.58.94,3.67,1,4.92-1a3.5,3.5,0,0,0,.42-1c.15-.61.2-1.77.42-2.53-.05-1.89-.14-3.78-.26-5.66A2.19,2.19,0,0,1,387.85,238.81Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.06,282.29a8.28,8.28,0,0,1-3.9-.28c-1.23-.35-2.68-.76-3.67,0-.74.6.57,1.25,1.23,1.5a12.35,12.35,0,0,0,1.51.45c.84.21,2,.73,2.67.88a1.81,1.81,0,0,0,1.12-.05c1.41-.52,2.65-1.83,4.43-1.14.41.16,1.2.78,1.63.6l.08,0c.42-.31.09-1.14-.24-1.53C165.63,281.17,163.36,282,162.06,282.29Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.79,225.26a1.46,1.46,0,0,0-1.39-1.59c-.52-.09-.45.46-.31,1.08C261.27,225.54,262.65,226.56,262.79,225.26Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.28,224.28c.42-.78.12-1.38-1.61-.83-.28.06-.57.65-.7,1.24C245.78,225.52,247.57,225.58,248.28,224.28Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.42,181.92c.42-2.11-2.58-4.37-3.5-4-.55.24-1,.92-1.38,1.25a11.41,11.41,0,0,1-1.82.7c-1,.39-1.64,2.12-2.65,1.34s-.88,2.56.67,4.09C206.31,188.88,210.78,185.09,211.42,181.92Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.13,209.34c-.29,1.94,0,3.6.85,3.76s2.63-1.58,4-2.36c1.92-1.11,0-1.63-1.74-2.65C139.05,207.41,137.42,207.4,137.13,209.34Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.59,164.79c.89-1.11,2.39-3.27,1.39-5.28-.59-1.2-1.43-1.47-1.79-2.88A5.51,5.51,0,0,1,193,155a16.27,16.27,0,0,1,.69-2.69,1.68,1.68,0,0,0-.23-1.46c-.59-.88-1.52-.72-2.14-1.18-3.2-2.37,3.19-10.36,2-11.58a1.18,1.18,0,0,0-.82-.27,7,7,0,0,0-1.79.21,3,3,0,0,0-.94.43,3.1,3.1,0,0,0-.88,1.33c-.4.89-.93,1.9-1.22,1.71-.12-.07-.23-.29-.5-.54-.78-.72-.66,0-1.23.51-.29.27-1.39.68-1.74-.31s.44-2.34.61-3a2.52,2.52,0,0,1,.67-1.23c.48-.47.05-1.82-1-2.38a6.19,6.19,0,0,0-3.19-.54,9.33,9.33,0,0,0-5.7,2.32,13.24,13.24,0,0,0-2.47,2.64c-1,1.43-1.66,4.24-2.82,5.86a2.24,2.24,0,0,1-2.29,1c-1.46,0-3.34,0-5.09,3.18-1.08,2,0,1.86-.28,3.49s-2,1.79-2.6,2.24a3.39,3.39,0,0,0-1.22,3.7c.11.32.09.61-.59,1.64a26.28,26.28,0,0,1-3,3.57,6.41,6.41,0,0,0-1.75,3.36c-.27,1.31.14,1.17.57,1.45a1.73,1.73,0,0,1,.55.56c.26.41.62,1.61,1.22,1.64s2.13-1.19,3.3-2c2-1.41,3.89-2.54,5.41-1a4.58,4.58,0,0,1,1.07,1.92,21.64,21.64,0,0,1,.2,5.71,4.13,4.13,0,0,0,.35,2.47c.84,1.15,2.4.72,3.31,2.05.72,1,.72,2.78.39,4.43-.37,1.83-1.2,2.68-1.76,4.29s.15,3,.32,4.49a13.94,13.94,0,0,0,1.66,5,39.87,39.87,0,0,0,3,4.8,6.24,6.24,0,0,0,1.48,1.57c.92.63,2.91.29,4.2-.41a4.68,4.68,0,0,0,2-2.07c1-2.16,0-4.8,0-7.14a5.86,5.86,0,0,1,2-4.63c1.11-1,2.71-1.93,3.44-3.56.6-1.34.68-3.2,1.36-4.47.91-1.7,2.91-2.18,4.15-3.18.86-.69,2.54-2.22,2.33-3.72-.12-.81-.52-1.14-.35-2a3,3,0,0,1,.81-1.3,8.29,8.29,0,0,1,.66-.51c.36-.29.25-1.32-.18-1.73s-.62-.53-.78-.72C193,167.45,192.53,166.11,193.59,164.79Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.26,192.47c.46-.62,1-1.37.67-1.6-.1-.09-.29,0-.4-.11s-1,.15-2.34,1.36-1.34,2.75-2.3,3.51.4,2.55,1.48,2.84c1.62.43,3-1.61,3.58-3.36C129.72,192.88,127.61,193.35,128.26,192.47Z",
    style: {
      fill: "#51A2E5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M266.61,123c-91.19-11.47-98.13,50.54-46,80.76s133.29,30.1,140.09,3.72S334.39,131.54,266.61,123Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204,337.78c-82.14-33.64-80.42-168.12-17.75-210.86h0c-2.38,1.23-4.75,2.52-7.08,3.91A138.64,138.64,0,1,0,384.66,283C372.7,314.6,290.18,373.09,204,337.78Z",
    style: {
      fill: "#51A2E5"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-6--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.6,446.93a38.4,38.4,0,1,1,38.4-38.4A38.44,38.44,0,0,1,405.6,446.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.6,371.13a37.4,37.4,0,1,1-37.4,37.4,37.4,37.4,0,0,1,37.4-37.4m0-2a39.4,39.4,0,1,0,39.4,39.4,39.44,39.44,0,0,0-39.4-39.4Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.86,387.61a4.52,4.52,0,0,1,2.74.21,29.67,29.67,0,0,1,3.93,2.2c2,1.09,5.24,2.88,7.56,2.78.47,0,1.45-.21.81-.8a20.34,20.34,0,0,1-2.45-2.37,4.13,4.13,0,0,1-.95-3.17,1.42,1.42,0,0,1,.47-.89c.39-.29.66-.1,1,.13a9,9,0,0,0,1,.63l2.18,1.25c4.23,2.47,8.45,5.37,10.95,9.7.36.63,2.55,5.58,3.95,8.37,1.15,2.55,9.84,18.5,9.84,18.5l15.49-15.1c3.47-3.47,6.94-6.69,10-7.87a42.69,42.69,0,0,0,5.38-2.79L383,425.73s-16.37,12.32-18.7,14c-3.47,2.51-10.4,6.57-13.84,2.32-4.66-5.76-6.93-14.06-9.11-20.4s-3.34-10.19-4.59-12.38-3.3-2.34-4.74-2.79a22.49,22.49,0,0,1-5.69-2.48,20.9,20.9,0,0,1-4.37-3.22,6.39,6.39,0,0,1-1.68-2,21,21,0,0,0-.41-2.16,21.73,21.73,0,0,1-1.31-2.21,7.59,7.59,0,0,1-.14-2A3.4,3.4,0,0,0,317,390a3.12,3.12,0,0,1-.94-1.11C315.75,388.13,316.25,387.77,316.86,387.61Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.46,397.78a23.3,23.3,0,0,0-9.28,4.5c-3.72,2.9-22.09,19.1-22.09,19.1L350.29,410s-.13,3-4.49,5.54c-4.6,2.67-6.26,1.76-6.26,1.76S343,431,346.71,437.77s5.9,8.94,12,6.17,27.07-18.38,27.07-18.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.74,394.82a15.08,15.08,0,0,0,5.19,6.53,6.2,6.2,0,0,1-3.86-2A5.81,5.81,0,0,1,333.74,394.82Z",
    style: {
      fill: "#f0997a"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M358.09,421.38c2.62,4.54,3.44,10.38,2.9,13.37,1.9-4.81,2-9.76-1.21-14.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M433,419c-.76,4.59-2.44,12.14-3.56,18.35a37.41,37.41,0,0,1-49.08-1.28v-5.31s-4.27-4-3.62-11.39,10.22-19.18,12.75-21.63c2-.79,10.86-2.33,10.86-2.33A86.48,86.48,0,0,1,421.76,398c2.7.7,6.23,1.91,6.23,1.91C429.12,402.84,434.3,411.05,433,419Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.55,367.69c-4.12-15.19,9.88-23,23.82-20.51,4.59.8,10.51,3.43,11.15,10,6.06,1.9,9,10,5.23,18.68-2.72,6.28-8.14,9.41-10.6,13.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.79,369.86c-3.89-1.7-5.85,2.37-5.85,2.37-2.54,1.58-4-3.5-4.55-5-1-2.67-1.89-6.48-4.85-7.58-2.2-.83-4.69,0-6.7,1.2a5.13,5.13,0,0,1-4,.53c-1.21-.33-1.59-2.21-2.69-2.8-3.16-1.7-5.32,3.58-6.05,6a30.27,30.27,0,0,0-1,9.39c.23,11.32,3,16.32,6.17,17.66a15.82,15.82,0,0,0,8.08,1L400.3,396a15.2,15.2,0,0,0-2.71,11.64c6.31-.72,15.55-4.17,18.58-9.89l0-16.78c.71,1.48,4.07,2.19,6.15-.47C425,377,425.53,371.49,421.79,369.86Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.5,383.83l5.31-1.2a2.8,2.8,0,0,1-2,3.45A2.86,2.86,0,0,1,396.5,383.83Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.65,386.06a2.56,2.56,0,0,0,1.17,0,2.66,2.66,0,0,0,2-2.06A3.1,3.1,0,0,0,398.65,386.06Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.36,392.61c3.67-.56,10.36-2.35,11.47-5.37,0,0,.17,2.45-2.66,4.61-2.37,1.81-8.85,2.94-8.85,2.94Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.86,366.15l3.78-1.09a1.9,1.9,0,0,0-2.37-1.38A2.06,2.06,0,0,0,388.86,366.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.62,367.27l-3.74-1.2a1.88,1.88,0,0,1,2.41-1.31A2.06,2.06,0,0,1,405.62,367.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.12,372a1.6,1.6,0,1,0,3.19.24,1.62,1.62,0,0,0-1.46-1.77A1.64,1.64,0,0,0,389.12,372Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.18,372.87a1.63,1.63,0,0,0,1.46,1.78,1.65,1.65,0,0,0,1.73-1.54,1.6,1.6,0,1,0-3.19-.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.9,372.07a.4.4,0,0,1,.23-.17l.51-.18.68-.24a5.62,5.62,0,0,1,.58-.19l.36-.08a1.55,1.55,0,0,1,.48,0c.13,0,.15.19.12.29a.41.41,0,0,1-.28.29l-.27.08-.19,0-.08,0h0l-.18,0-.6.19a3.24,3.24,0,0,1-.8.2.82.82,0,0,1-.41-.06A.22.22,0,0,1,404.9,372.07Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,373.31a.88.88,0,0,1,.58-.33,5.48,5.48,0,0,1,1-.05c.38,0,.75,0,1.13.05s.15.57-.12.6a7.39,7.39,0,0,1-1.41,0h-1c-.1,0-.09,0-.16-.1A.12.12,0,0,1,405,373.31Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.07,374.11c.09-.09.23,0,.35,0l.24.06.51.16.47.13.2.05a1.84,1.84,0,0,1,.25.09.19.19,0,0,1,.14.19v.05a.31.31,0,0,1-.16.27.48.48,0,0,1-.23.05h-.07l-.22,0-.25-.06-.51-.16a1.72,1.72,0,0,1-.6-.31.45.45,0,0,1-.14-.19A.24.24,0,0,1,405.07,374.11Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.13,368.18a3.33,3.33,0,0,0,.76,1.68,1.59,1.59,0,0,1,.31.61,30.85,30.85,0,0,0,1.1,4.49,5.38,5.38,0,0,0,4.84,3.42,7,7,0,0,0,1.62-.05l.12,0a4.46,4.46,0,0,0,1.32-.45l.08,0,.11-.07.14-.09.13-.09.14-.11.14-.12a2.83,2.83,0,0,0,.25-.24,5.86,5.86,0,0,0,1-1.63c.66-1.52.45-3.7,1.58-3.89h.28c1.55.11,1.41,2.46,2.3,4.2a6.28,6.28,0,0,0,5.69,3.69l.44,0h.34a6.61,6.61,0,0,0,.81-.07l.25-.05.24-.05.15,0a4.13,4.13,0,0,0,.9-.38l.3-.19a3.6,3.6,0,0,0,.52-.43,4.82,4.82,0,0,0,1-1.51,26.77,26.77,0,0,0,.84-4.36,1.87,1.87,0,0,1,.25-.62,2.81,2.81,0,0,0,.73-1.55,1.49,1.49,0,0,0-.95-1.44l-.83-.16c-2.64-.46-6.09-.79-8.14-.34-2.58.57-3.46,1.34-4.9,1.25s-2.24-1-4.7-2a22.54,22.54,0,0,0-7.64-.8l-.76,0C382.5,366.86,382.07,367.47,382.13,368.18Zm17,2.54a1.94,1.94,0,0,1,.73-.56l.13-.07.07,0,.36-.16.34-.12a8.41,8.41,0,0,1,1.1-.28l.43-.08a11,11,0,0,1,1.14-.12h.26c2.49-.07,4.05.6,4.62,1.14s.36,2.84.15,4l0,.09s0,.06,0,.09-.06.3-.1.46,0,.19-.07.29h0a3,3,0,0,1-.16.48h0L408,376l0,.09-.05.11s-.05.09-.07.14a1.09,1.09,0,0,1-.08.15l-.1.16-.1.15a3.63,3.63,0,0,1-3.46,1.45,5.17,5.17,0,0,1-3.69-1.59h0a5.6,5.6,0,0,1-1.24-2.43C398.88,372.93,398.68,371.4,399.15,370.72Zm-14.65-2a1.66,1.66,0,0,1,.6-.35l0,0a1.07,1.07,0,0,1,.27-.09l.16-.05.13,0,.1,0h0l.14,0a4.54,4.54,0,0,1,.57-.06h.64l.39,0h.29c.35,0,.74.09,1.15.17,1.77.36,3.64,1.28,4.13,2s.41,2.26.2,3.55a4.85,4.85,0,0,1-.21.86.14.14,0,0,1,0,.06l0,.09,0,.06,0,.1a2,2,0,0,1-.1.21.76.76,0,0,1-.09.18l0,.06-.07.12a.61.61,0,0,1-.07.1v0a3.62,3.62,0,0,1-3.66,1.48,4.53,4.53,0,0,1-1.87-.54,5.78,5.78,0,0,1-2.49-3.93C384.36,371.51,384,369.18,384.5,368.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,369l7.68,1.42a6.1,6.1,0,0,0-1.47,1.55L410,370.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.73,371.79l-1,9.22-5.43-1.9,5.89-7.53A1.33,1.33,0,0,1,396.73,371.79Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.69,379.08a1.44,1.44,0,1,0,1.44-1.44A1.45,1.45,0,0,0,417.69,379.08Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M390.09,450.79c-2.56-.26-5-2.62-8.3-3.87s-6.1-1.28-8.35-2.2c-.93.53-.45,2.49.66,3.34,1.71,1.31,4.34,2.14,3.71,2.84-.92,1-4.46.32-5.54.1-3.31-.69-6.83-2.67-10.28-1.94a1.49,1.49,0,0,0-.95.51,1.19,1.19,0,0,0,.27,1.41,7.55,7.55,0,0,0,1.27.88,1.72,1.72,0,0,1,.88,1.21c0,.47-.25.92-.19,1.39a1.82,1.82,0,0,0,.4.81,5.74,5.74,0,0,0,1.23,1.13,7.93,7.93,0,0,1,1.14.78,11.77,11.77,0,0,1,2,2c1.81,2.95,5.7,3.84,8.85,4.38,6.74,1.17,9.84-.24,13.81-.17s20.91-.44,29.6-1.06c9.11-.65,10.21-2.35,12.78-11a249.47,249.47,0,0,0,6.82-31c1.44-10.91,0-16.54-10.8-19.95-3,2.06-6.78,9.54-8.61,24l-3.89,21.81S392.65,451.05,390.09,450.79Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,399.87c4.86,1,9.33,2.32,11.83,6.25s1.59,8.24.56,16.39-6.65,29.39-8.06,33.91-2.26,5.55-7.09,6.39-29.55,1.07-29.55,1.07.93-2.16.55-6.89-1.91-6.66-1.91-6.66l22-4.51s3.38-20.39,4.59-26.79S423.48,405.73,428,399.87Z",
    style: {
      fill: "#263238"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M416.31,445.82c2.94-.32,7.89,1.66,9.35,4.39-.61-2.87-3.66-6-9.05-6Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 302.63,
    cy: 324.44,
    r: 2.36,
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.95 385.58 323.44 324.94 302.63 324.94 302.63 323.94 323.89 323.94 376.71 384.93 375.95 385.58",
    style: {
      fill: "#51A2E5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.66,449.48a38.41,38.41,0,1,1,38.4-38.41A38.45,38.45,0,0,1,91.66,449.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.66,373.67a37.41,37.41,0,1,1-37.4,37.4,37.4,37.4,0,0,1,37.4-37.4m0-2a39.41,39.41,0,1,0,39.4,39.4,39.45,39.45,0,0,0-39.4-39.4Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.91,374.84c.54-2.95.81-4.15.39-4.95-.32-.61-.7-.86-1.1-.81.11-.88.12-2.34-1.35-2.65L160,365c.11-1.11-.4-1.89-1.21-2,.72-1.91.65-3.49-.37-3.86-.34-.13-2.13,1.29-3.18,2.29-3.62,3.46-3.6,1.92-6.27,8.44-.91,2.23-2.76,5.38-3.45,9.1-.38,2.08,1,9-1.14,14.38-1.77,4.38-5.37,10.92-10.21,19.05,0,0-4.26-4-9.31-9.32-9-9.59-9.7-11.5-16.22-12.81-6.6,3-3.16,17.68.75,24.64a191,191,0,0,0,22.22,17.7c8,5.3,12,4.26,14.89-1.68,4-8.15,9.55-29.39,10.67-33.37,1-3.62,3.5-4.08,4.25-7.72,1.1-5.33-.78-8.8-.27-11.25C161.32,377.62,161.63,376.35,161.91,374.84Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.16,412.42c-2.52,4.37-3.85,7.17-3.25,11.89-1.87-4.17-.6-9.05,2-13.09Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.29,382.07c2.58,2.54,3.3,8.07,1.49,11.07C158.39,391.05,159,385.52,154.29,382.07Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.08,369.61l-.12.28c-.15.38-.34.8-.54,1.24l.76,4.61-1.43,1.43a4.8,4.8,0,0,0-1.45,3.42l3.95-3Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.64,389.82c4.85,1.07,6.28,1.57,9,4.14s14.51,15.26,14.51,15.26-3.89.74-7.32,6-3.18,9.65-3.18,9.65L109,415S99.45,397.78,107.64,389.82Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.64,389.82c4.85,1.07,6.28,1.57,9,4.14s14.51,15.26,14.51,15.26-3.89.74-7.32,6-3.18,9.65-3.18,9.65L109,415S99.45,397.78,107.64,389.82Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.49,351.49l-13.13,7.58a1.16,1.16,0,0,0-.6,1.11l4.32,30.19a1.6,1.6,0,0,0,.88,1.13,1.93,1.93,0,0,0,1.52-.11l13.07-7.55a1.35,1.35,0,0,0,.64-1.24l-4.31-30.09a1.62,1.62,0,0,0-.88-1.13A1.9,1.9,0,0,0,161.49,351.49Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.05
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.49,351.49l-13.13,7.58a1.16,1.16,0,0,0-.6,1.11l4.32,30.19a1.6,1.6,0,0,0,.88,1.13,1.93,1.93,0,0,0,1.52-.11l13.07-7.55a1.35,1.35,0,0,0,.64-1.24l-4.31-30.09a1.62,1.62,0,0,0-.88-1.13A1.9,1.9,0,0,0,161.49,351.49Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M154.29,391.48a1.91,1.91,0,0,1-1.33,0,1.6,1.6,0,0,1-.88-1.13l-4.32-30.19a1,1,0,0,1,.12-.6l1.4.58a1.1,1.1,0,0,0-.26.83l4.28,29.9A.69.69,0,0,0,154.29,391.48Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.29,391.48a1.91,1.91,0,0,1-1.33,0,1.6,1.6,0,0,1-.88-1.13l-4.32-30.19a1,1,0,0,1,.12-.6l1.4.58a1.1,1.1,0,0,0-.26.83l4.28,29.9A.69.69,0,0,0,154.29,391.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M149.58,359.9A1.16,1.16,0,0,0,149,361l4.28,29.9c.08.6.61.83,1.18.5l13.07-7.55a1.35,1.35,0,0,0,.64-1.24l-4.31-30.09c-.06-.44-.45-.61-.87-.37Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.58,359.9A1.16,1.16,0,0,0,149,361l4.28,29.9c.08.6.61.83,1.18.5l13.07-7.55a1.35,1.35,0,0,0,.64-1.24l-4.31-30.09c-.06-.44-.45-.61-.87-.37Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.39,361.67a1.3,1.3,0,0,0-.61,1.18l3.85,26.84a.5.5,0,0,0,.82.35l12.3-7.1a1.28,1.28,0,0,0,.61-1.18l-3.84-26.84c-.06-.42-.43-.58-.83-.35Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.66,362.69l-3.36,1.84c-.48.27-.91.22-1-.11s.31-.81.79-1.07l3.36-1.85c.48-.26.91-.21,1,.11S163.14,362.42,162.66,362.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,365l-3.35,1.84c-.49.27-.92.22-1-.11s.3-.81.79-1.07l3.35-1.85c.49-.26.92-.21,1,.11S163.52,364.69,163,365Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.74,370l-3.36,1.84c-.48.27-.91.22-1-.11s.31-.81.79-1.07l3.36-1.85c.48-.27.91-.22,1,.11S164.22,369.71,163.74,370Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.12,372.25l-3.36,1.84c-.48.27-.91.22-1-.11s.31-.81.79-1.07l3.36-1.85c.48-.27.91-.22,1,.11S164.6,372,164.12,372.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.82,377.26l-3.35,1.85c-.49.27-.92.22-1-.11s.3-.81.79-1.07l3.35-1.85c.49-.27.92-.22,1,.11S165.3,377,164.82,377.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.2,379.53l-3.36,1.85c-.48.27-.91.22-1-.11s.31-.81.79-1.08l3.36-1.84c.48-.27.91-.22,1,.11S165.68,379.27,165.2,379.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.32,366.24l4.69-2.7a.3.3,0,0,1,.49.25l.59,4.54a.82.82,0,0,1-.36.75l-4.62,2.67a.32.32,0,0,1-.51-.25L152,367A.81.81,0,0,1,152.32,366.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.34,373.39l4.68-2.7a.31.31,0,0,1,.5.24l.59,4.55a.81.81,0,0,1-.37.75l-4.62,2.67a.32.32,0,0,1-.5-.25l-.65-4.51A.82.82,0,0,1,153.34,373.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.35,380.54l4.69-2.71a.32.32,0,0,1,.5.25l.59,4.55a.82.82,0,0,1-.37.74L155.14,386a.31.31,0,0,1-.5-.24l-.65-4.52A.79.79,0,0,1,154.35,380.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.59,363.24l0-.17a.07.07,0,0,1,0-.08h0s0,0,0,0l0,.17s0,.07,0,.08h0S150.59,363.28,150.59,363.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.75,363.15l-.05-.29s0-.07,0-.08h0s0,0,0,.05l0,.29a.07.07,0,0,1,0,.08h0S150.75,363.19,150.75,363.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.9,363.06l-.06-.41a.12.12,0,0,1,0-.09h0s0,0,0,0l.06.42a.07.07,0,0,1,0,.08h0S150.91,363.1,150.9,363.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,363l-.1-.71a.09.09,0,0,1,0-.08h0s0,0,0,.05l.1.7s0,.08,0,.09h0S151.07,363,151.06,363Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.49,362.77v0l0-.1-.18.1h0v-.08l.14-.48v0h0l0,0h0v0l.05.37,0,0h0a0,0,0,0,1,0,0v0a0,0,0,0,1,0,0h0l0,0,0,.1a0,0,0,0,1,0,0h0l0,0Zm0-.22,0-.26-.09.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.69,362.59a.34.34,0,0,1-.08-.21.6.6,0,0,1,0-.27.34.34,0,0,1,.14-.17l.07,0h.07V362h0a.1.1,0,0,0-.09,0,.27.27,0,0,0-.09.12.43.43,0,0,0,0,.2.27.27,0,0,0,.06.16.09.09,0,0,0,.1,0l0,0,0,0,0-.17-.07.05h0v-.08h0l.11-.07h0s0,0,0,0l0,.24v0a.4.4,0,0,1-.13.13A.15.15,0,0,1,151.69,362.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.83,355.55a.06.06,0,0,0-.08,0l-.52.3a.21.21,0,0,0-.06.2l.05.37a.16.16,0,0,0,.05.11l0,0h0l.53-.3a.21.21,0,0,0,.05-.2l-.05-.37A.13.13,0,0,0,162.83,355.55Zm-.55.92s0,0,0-.06l0-.36a.15.15,0,0,1,0-.15l.52-.31h0s0,0,0,0l0,.36a.18.18,0,0,1,0,.16l-.53.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.55,355.8l.06.43-.28.16h0v0l0-.32a.14.14,0,0,1,0-.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.91,355.65s0,0,.05.11v.07c0,.08,0,.15,0,.16l0,0,0-.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.69,362a.2.2,0,0,1-.08.21c-.05,0-.11,0-.12-.09a.2.2,0,0,1,.08-.2C152.63,361.84,152.68,361.87,152.69,362Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.54,361.63a.48.48,0,0,0-.21.34.06.06,0,0,0,0,.07h0s.05,0,.06-.06a.39.39,0,0,1,.14-.24.13.13,0,0,1,.19.05s0,0,.06,0h0s0-.06,0-.07A.18.18,0,0,0,152.54,361.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.5,361.4a.79.79,0,0,0-.32.49s0,.07,0,.08h0s.05,0,.06-.05a.61.61,0,0,1,.26-.41.25.25,0,0,1,.33.06s.05,0,.06,0h0s0-.06,0-.08A.31.31,0,0,0,152.5,361.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.6,359.78v0h-.05l-.07-.5-.09.17h0l0,0h0a0,0,0,0,1,0,0l.11-.23h.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.7,359.3h0v.06s0,0,0,0h0l0,0h0s0,0,0,0v-.08h0Zm0,.31h0s0,0,0,0v.08a0,0,0,0,0,0,0l0,0h0v-.08h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.07,359.54h0a0,0,0,0,1,0,0l0-.13-.2.12h0v0s0,0,0,0v0l.15-.49v0h0l0,0h0v0l.06.37,0,0h0v.07h0l-.06,0,0,.12v0l0,0Zm0-.22,0-.25-.1.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.27,359.26v0s0,0,0,0h0l0,0,0,0,0,0a66636439945.93,66636439945.93,0,0,0,0-.1s0,0,0-.05l0,0h0l0,0,0,0h0v0a0,0,0,0,1,0,0v0l.09-.24-.18.11h0v-.07l0,0,.25-.14h0v0h0v0l-.08.24.06,0h.05l0,0,0,.07a.28.28,0,0,1,0,.09.19.19,0,0,1,0,.08.43.43,0,0,1,0,.07l-.06.05-.08,0h-.06l0,0s0,0,0-.05v0h0l0,0h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.52,357.46l2.18-1.26c.13-.08.25,0,.27.1a.44.44,0,0,1-.21.37l-2.18,1.26c-.13.07-.25,0-.27-.1A.43.43,0,0,1,155.52,357.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.26,355.29a.15.15,0,0,1,.25.11.37.37,0,0,1-.19.36c-.12.07-.23,0-.25-.1A.39.39,0,0,1,159.26,355.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.14,354.78a.16.16,0,0,1,.26.11.41.41,0,0,1-.19.36c-.12.07-.24,0-.26-.1A.43.43,0,0,1,160.14,354.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.07,358.86a.16.16,0,0,1,.26.11.43.43,0,0,1-.19.37.16.16,0,0,1-.26-.11A.41.41,0,0,1,153.07,358.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,358.35c.13-.07.24,0,.26.11a.41.41,0,0,1-.19.37.15.15,0,0,1-.25-.11A.4.4,0,0,1,154,358.35Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.61,385.9c0-4.42.7-6.78,2.87-8.59,2.87-2.37,3.84-6.75,4.92-6.51,1.29.29,2.43,3.08.72,6.64-1.94,4-2.93,6.76-2.62,8.89C151.86,388.84,145.61,385.9,145.61,385.9Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,438.6A37.39,37.39,0,0,1,65,437.34V426.43l.31-3.9h0l2.46-31.34a113.3,113.3,0,0,1,17.57-3.51,52.35,52.35,0,0,1,15.07.72C110,390,114.2,389.7,115.4,406.33,115.91,413.36,116.58,426.57,117,438.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-17"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.82,373.7l-.3-5s3.2-4.42,3.53-8c.42-4.65-.56-6.54-.56-6.54-1.62-1.22-5.25-4.25-7.33-4.43-3-.25-4.73,4.11-5.11,5.69a23.93,23.93,0,0,0,2.53,16.07c1.36,2.61,4.56,5.41,5.82,9.21A17.16,17.16,0,0,0,81.82,373.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.22,349.37c-1.77,7.21,13.13,22.41,20.56,22.34s12.49-9.89,12.42-17.32-3.66-12.64-14.45-13.57C88.35,340.19,78.87,342.67,77.22,349.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.63,375.73a4,4,0,0,0,4.56-.8l.57,15.39a11.82,11.82,0,0,0,5.42,5.18c3.69,1.6,8.38,2.33,11.47,1.16s4.71-3.6.24-7.38l-.17-4.56a28.26,28.26,0,0,0,5.23-.06c3.3-.54,5.36-3.18,6.33-6.76,1.55-5.77,1.11-14.4-1.18-25.56-3.72-2.84-15.87-3.21-23.62,1.77.42,6.58-.58,8.85-.81,9.84s-1.48,3.6-2.33,3.74c-1.58.25-1.84-1.47-2.86-2.53A4.33,4.33,0,0,0,72,367C70.32,370.58,73.36,374.86,75.63,375.73Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.72,384.72c-5.27-.49-11.83-2.89-13.53-5.29a17.84,17.84,0,0,1-2.33-4.37s.22,4.16,1.52,6.26,6.18,5.65,14.44,6.15Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.57,365.12a1.49,1.49,0,0,1-1.46,1.54,1.54,1.54,0,1,1,1.46-1.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3,359,91,360.48A1.9,1.9,0,0,1,92,358,1.76,1.76,0,0,1,94.3,359Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.42,360.18l-3.53-.88a1.75,1.75,0,0,1,2.14-1.36A1.92,1.92,0,0,1,107.42,360.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.59,364.84a1.5,1.5,0,0,1-1.46,1.54,1.54,1.54,0,1,1,1.46-1.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.17,360.29l-11.39,4a3.75,3.75,0,0,1,3.28,1.52l8.07-3.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.4,359.75l-.75-.08a21.59,21.59,0,0,0-7.45.38c-2.38.78-3.23,1.62-4.55,1.66s-2.29-.8-4.8-1.49a24.76,24.76,0,0,0-8-.09l-.8.1a1.35,1.35,0,0,0-.91,1.37,3,3,0,0,0,.73,1.55,1.74,1.74,0,0,1,.26.62,26.55,26.55,0,0,0,.89,4.3,5.16,5.16,0,0,0,1,1.54,4.43,4.43,0,0,0,.51.45l.3.2a5.54,5.54,0,0,0,.88.42l.16,0a1.25,1.25,0,0,0,.23.07,1.83,1.83,0,0,0,.25.06,4.55,4.55,0,0,0,.78.12l.34,0h.42a5.64,5.64,0,0,0,5.5-3.32c.84-1.64.68-4,2.18-4h.15l.13,0c1.11.25.93,2.37,1.61,3.89a5.88,5.88,0,0,0,1,1.65,2,2,0,0,0,.25.25l.13.12.14.12.13.09.14.1.11.07.07.05a5,5,0,0,0,1.29.5l.13,0a7,7,0,0,0,1.59.13,4.79,4.79,0,0,0,4.67-3.08,29,29,0,0,0,1-4.34,1.52,1.52,0,0,1,.29-.57,3.1,3.1,0,0,0,.72-1.6A1.28,1.28,0,0,0,113.4,359.75Zm-15.79,6.4a5.2,5.2,0,0,1-1.18,2.3,4.68,4.68,0,0,1-3.59,1.36,3.8,3.8,0,0,1-3.39-1.59.75.75,0,0,1-.1-.17l-.1-.15-.09-.16-.06-.14a.31.31,0,0,1,0-.1l0-.1a1.11,1.11,0,0,1-.07-.16c-.07-.17-.12-.32-.17-.48h0c0-.09,0-.19-.07-.29s-.08-.32-.11-.45,0-.07,0-.09,0-.06,0-.09c-.23-1.14-.48-3.38.09-3.9s2.06-1.07,4.49-.87l.26,0a10.64,10.64,0,0,1,1.11.17l.43.11a7,7,0,0,1,1.07.34l.33.13a4,4,0,0,1,.36.17l.07,0,.13.06a2.39,2.39,0,0,1,.72.59C98.07,363.38,97.91,364.87,97.61,366.15Zm14.2-.74c-.21.89-.65,2.82-2.37,3.7a4.21,4.21,0,0,1-1.82.43,3.8,3.8,0,0,1-3.6-1.64v0a.61.61,0,0,1-.07-.1.49.49,0,0,1-.06-.13l0,0c0-.07-.07-.13-.09-.19a1.36,1.36,0,0,1-.1-.21.42.42,0,0,1,0-.1l0-.06,0-.08a.19.19,0,0,1,0-.07,6,6,0,0,1-.23-.84c-.22-1.27-.33-2.76.15-3.46s2.28-1.52,4-1.77c.4-.05.77-.09,1.11-.1h1l.3,0c.2,0,.39.05.56.09l.14,0h0l.08,0,.14,0,.17.05.26.11h0a2.51,2.51,0,0,1,.59.38C112.4,362,112.06,364.25,111.81,365.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.11,370.93l-5.34,1.36-.86-8.35a1,1,0,0,1,.7-.25h.13l.14,0a.6.6,0,0,1,.3.14C101.26,363.9,106.11,370.93,106.11,370.93Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,374.39l6.19,1.33a3.11,3.11,0,0,1-3.69,2.54A3.32,3.32,0,0,1,95,374.39Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.73,375.4a4,4,0,0,0-.77,0,3.29,3.29,0,0,0,2.52,2.85,3.12,3.12,0,0,0,1,0A2.89,2.89,0,0,0,95.73,375.4Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.78,450.82c2.42,1.37,6,.84,9.72,1.8s6.17,2.69,8.72,3.3c.49,1.05-1.17,2.47-2.67,2.52-2.33.08-5.16-.84-5,.16.17,1.5,3.73,3.09,4.81,3.57,3.34,1.47,7.67,1.92,10.25,4.73a1.55,1.55,0,0,1,.51,1.05A1.3,1.3,0,0,1,101,469a7.78,7.78,0,0,1-1.67,0,1.89,1.89,0,0,0-1.53.51c-.33.39-.37,1-.71,1.34a1.72,1.72,0,0,1-.86.46,6,6,0,0,1-1.79.23,9.15,9.15,0,0,0-1.48,0,13.13,13.13,0,0,0-3,.48c-3.44,1.46-7.41-.2-10.52-1.69-6.66-3.19-8.83-6-12-8.8-4.25-3.78-12.56-11.33-18.88-17.86-6.85-7.08-7.78-8.55-4.31-17.7,3.61-9.55,4.27-11.31,7.85-18.22,4.67-9,6.14-14,15.74-16,2.93,2.79,4.85,10.54,1,25.29l-6.91,14.74S73.37,449.45,75.78,450.82Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.83,416.86l-7.3,13.74c-3.58,0-13.94-4.23-16.51-10,3.83-9.54,5-11.95,8-18.23,4.16-8.65,7.54-10.33,16.33-11.9C75,399.42,71,413.89,69.83,416.86Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.83,416.86l-7.3,13.74c-3.58,0-13.94-4.23-16.51-10,3.83-9.54,5-11.95,8-18.23,4.16-8.65,7.54-10.33,16.33-11.9C75,399.42,71,413.89,69.83,416.86Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 203.26,
    cy: 317.05,
    r: 2.36,
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.31 388.13 120.55 387.47 182 316.55 203.26 316.55 203.26 317.55 182.46 317.55 121.31 388.13",
    style: {
      fill: "#51A2E5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 448.59,
    cy: 256.97,
    r: 38.4,
    transform: "translate(123.09 658.6) rotate(-80.78)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.59,219.57a37.4,37.4,0,1,1-37.4,37.4,37.39,37.39,0,0,1,37.4-37.4m0-2A39.4,39.4,0,1,0,488,257a39.44,39.44,0,0,0-39.4-39.4Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ponytail--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.71,263.64c-5.68,1.5-14.31,1.56-18.5-3.29-4-4.59-4.19-9.73-4.36-15.49a6.94,6.94,0,0,0-.32-2.18,33.37,33.37,0,0,1-1-5.87q-.36-3-.46-6a83.48,83.48,0,0,1,.46-11.83,25.55,25.55,0,0,1,1.29-6.25,10.22,10.22,0,0,1,3.8-5,9,9,0,0,1,4.66-1.35,12.3,12.3,0,0,1,9.83,5.11c2.25,3.25,2.37,7.46,2.47,11.41a365.67,365.67,0,0,0,3.14,39,1.64,1.64,0,0,1-.21,1.36A1.67,1.67,0,0,1,470.71,263.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,209.33c1-1,5.2-.4,7.67,2.15s3.29,6.4,1.81,7.6S449.31,212.18,451,209.33Z",
    style: {
      fill: "#51A2E5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.26,257,434,280.85s-3.2,3.67-6.22,7.18a37.48,37.48,0,0,1-12.72-14.49c2.38-3.67,4.65-7,5.86-8.51C424.83,260.21,426.41,257.87,436.26,257Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.26,257,434,280.85s-3.2,3.67-6.22,7.18a37.48,37.48,0,0,1-12.72-14.49c2.38-3.67,4.65-7,5.86-8.51C424.83,260.21,426.41,257.87,436.26,257Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.49,275.61c-.81,3.48-1.86,8.11-2.88,12.95A37,37,0,0,1,451,294.29c-.79,0-1.59.08-2.39.08A37.22,37.22,0,0,1,427.77,288a34.52,34.52,0,0,1-3.36-2.55,36.22,36.22,0,0,1-4.54-4.56c0-.12,0-.23,0-.35-.11-5.67,1.37-8.71,6.46-15.14a109.43,109.43,0,0,1,8.26-9.32c.09-.09.17-.19.26-.27l.18-.18.15-.15a2.77,2.77,0,0,1,.25-.24,1,1,0,0,1,.15-.14l0,0h0l14.95-2.35,5.06,1.58,8.07,2.51C466,257.59,474.46,262.79,471.49,275.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.6,255.09l0,0a1,1,0,0,0-.15.14,2.77,2.77,0,0,0-.25.24l-.15.15-.18.18c-.09.08-.17.18-.26.27-3.36,3.76-6.94,11.51-8.3,16.39-1,2.23-1.55,7.05-1.86,13a36.22,36.22,0,0,1-4.54-4.56c-.37-.43-.72-.88-1.06-1.33a19.72,19.72,0,0,1,2-7.14C423.17,268,432.06,257,435.6,255.09Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M435.6,255.09l0,0a1,1,0,0,0-.15.14,2.77,2.77,0,0,0-.25.24l-.15.15-.18.18c-.09.08-.17.18-.26.27-3.36,3.76-6.94,11.51-8.3,16.39-1,2.23-1.55,7.05-1.86,13a36.22,36.22,0,0,1-4.54-4.56c-.37-.43-.72-.88-1.06-1.33a19.72,19.72,0,0,1,2-7.14C423.17,268,432.06,257,435.6,255.09Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M440.65,255.58c-2.49,1.71-13.61,9.36-15.83,24.24,0-6.56,2.47-14.6,4.82-18.41,2.86-4.65,6.65-9,10.91-10.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.34,286.65c-.42.33-.84.64-1.27.94s-1,.66-1.46,1A37,37,0,0,1,451,294.29c0-1.46,0-2.94,0-4.43.07-10.11,4.48-31.19,4.6-34,0-.65,0-1.16,0-1.56a5.29,5.29,0,0,0,0-1.42l6.41,2.68s4.35,1.15,7.09,2c3.31,1,3,5,3.53,9.41C473.25,272.42,472.28,279.79,471.34,286.65Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M471.34,286.65c-.42.33-.84.64-1.27.94s-1,.66-1.46,1A37,37,0,0,1,451,294.29c0-1.46,0-2.94,0-4.43.07-10.11,4.48-31.19,4.6-34,0-.65,0-1.16,0-1.56a5.29,5.29,0,0,0,0-1.42l6.41,2.68s4.35,1.15,7.09,2c3.31,1,3,5,3.53,9.41C473.25,272.42,472.28,279.79,471.34,286.65Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M429.87,214.62c-6.78.29-10.63,10.51-6,17.64,8.27,12.66,28.13,5.18,28.13,5.18l3.67,10.75s3.74-4.14,6.28-7.57c4.59-6.17,5.08-20.86-2.37-22.31C460.71,210.74,439.86,201.47,429.87,214.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.77,219.85c-1.1,2.22-3.73,5.6-3.32,18,.32,9.66,3.68,11.78,6.85,13,1.56.6,3.94.6,7.26.24l.09,4.52s-6,5.55-4.11,16.71c18.71-7.81,18.93-17.32,18.93-17.32l.51-15.1c.61,1,3.57,2.32,5.9-.66,2.74-3.5,2.13-7.68-.31-9.22s-5.41-.08-6.53,2.78c-2.62,1.09-6.11-1.63-5.94-11.79-3.21-1.68-9.45.69-11.45.47C434.64,221.11,432.87,218.19,429.77,219.85Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.42,237.88a1.39,1.39,0,1,1-1.57-1.17A1.38,1.38,0,0,1,460.42,237.88Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.56,251.06c8.13-1.76,12.69-5.06,13.52-8.35,0,0-.51,4.3-2.8,6.2-3.2,2.66-10.68,4.39-10.68,4.39Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.26,242.56l5.67-2.1a2.88,2.88,0,0,1-1.67,3.85A3.19,3.19,0,0,1,436.26,242.56Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,244.48a3.17,3.17,0,0,0,1.29-.17,2.87,2.87,0,0,0,1.87-2.43A3.47,3.47,0,0,0,439,244.48Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 442.18,
    cy: 232.82,
    rx: 1.65,
    ry: 1.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.3,232.26a1.65,1.65,0,1,1-1.64-1.63A1.64,1.64,0,0,1,432.3,232.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.65 229.2 436.77 240.2 431.53 238.13 437.65 229.2",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,229.57l3.77-1.31a1.93,1.93,0,0,0-2.48-1.26A2.08,2.08,0,0,0,428,229.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.34,230.13l-3.71-1.59a1.94,1.94,0,0,1,2.59-1.09A2.1,2.1,0,0,1,445.34,230.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.65,250c1.25-.06,1.57.71,3.23,2.59a24.51,24.51,0,0,0,3.1,3c-1.52,9.28-8.83,20.85-10.91,31.75-.09-8.82,2.27-20.95,4.51-34.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.45,270.56a37.42,37.42,0,0,1-13.38,17c-1.65-3-2.94-5.2-2.94-5.2s-5.55-15.5,1.95-24.82c6.29,1.49,9.58,3.34,11.56,7.33C481.51,266.66,482.47,268.53,483.45,270.56Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.45,270.56a37.42,37.42,0,0,1-13.38,17c-1.65-3-2.94-5.2-2.94-5.2s-5.55-15.5,1.95-24.82c6.29,1.49,9.58,3.34,11.56,7.33C481.51,266.66,482.47,268.53,483.45,270.56Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.72,267.22a2.36,2.36,0,1,0,2.36-2.36A2.36,2.36,0,0,0,298.72,267.22Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.14 267.72 301.08 267.72 301.08 266.72 323.79 266.72 336.76 256.47 411.19 256.47 411.19 257.47 337.11 257.47 324.14 267.72",
    style: {
      fill: "#51A2E5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.82,
    cy: 227.59,
    r: 38.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.82,190.18a37.41,37.41,0,1,1-37.4,37.41,37.41,37.41,0,0,1,37.4-37.41m0-2a39.41,39.41,0,1,0,39.41,39.41,39.45,39.45,0,0,0-39.41-39.41Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,242.79a37.34,37.34,0,0,1-11.2,14.3q-.8.63-1.62,1.2c-.59-.74-.92-1.17-.92-1.17l-4.55-29.58c4.65,1,6.91,1.49,9.89,4.33C79.42,233.59,82.63,237.93,86,242.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.81,257.09q-.8.63-1.62,1.2A37.4,37.4,0,0,1,29,257.19c-.4-.31-.79-.62-1.18-.95a36.54,36.54,0,0,1-4.49-4.48,87,87,0,0,1,.72-10,79.21,79.21,0,0,0,.82-9.47c0-.53,0-.78,0-.78l18.47-7,15.06,1.08,9.36,1.92c3.17,2.71,5.42,7.76,6.37,16.79C74.44,247.57,74.65,252.1,74.81,257.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.43,184.45a6.27,6.27,0,0,0-4.67,4.34c-1.07,2.9,0,8.22,1.31,14.61s2.23,9.14,3.09,10.92a4.85,4.85,0,0,0,2.73,2.35l.08-7.53-.1-5.25s3.53-4.48,4-8.23c.65-4.83-.31-6.85-.31-6.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.43,184.45c.89-4.2,6.9-9.21,15.35-8.38s12.63,3.34,15.4,8.38.62,8.67.62,8.67l-25.46-1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.43,211c2.72,1.89,5.3-.88,5.3-.88l.6,15.55s-.37,3,4.3,5.77c6.63,4,10.41,2.88,13.17,7,3.12-5.71,4.28-9.77-.72-13.53l0-3.55a28.49,28.49,0,0,0,5.45.16c3.47-.42,5.74-3.09,6.9-6.79,1.86-5.95,1.9-16.45-.85-27.22-4.45-3.62-15.73-3.53-24,1.34.16,6.88-1.85,9.87-1.92,12.37a6.89,6.89,0,0,1-1.56,1.88c-1.3,1.05-2.23-1.82-3.25-3s-4.45-2.76-6.29.82S31.07,209.37,33.43,211Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.06,196.22l-3.6,2.06a2.18,2.18,0,0,1,.8-2.91A2,2,0,0,1,52.06,196.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8,196.45l-4-1.3a2,2,0,0,1,2.57-1.38A2.19,2.19,0,0,1,66.8,196.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.13,200.41a1.7,1.7,0,1,0,1.69-1.69A1.7,1.7,0,0,0,50.13,200.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.31,
    cy: 199.64,
    r: 1.69,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8,196.09,58,206.36,64,205A20,20,0,0,0,56.8,196.09Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.58,200.28c.47,7.37,2.89,8.34,5.52,8.73,3.48.51,6.7-1.15,11.51-1.54,3.76-.31,5.14,1.17,7.29,2,1.6.62,2.86.59,3.24-1.2a46.84,46.84,0,0,0,.35-10,70.7,70.7,0,0,1,.31,13.4c-.46,3.48-1.33,6.74-3.22,8.39-2.62,2.29-8.21,2.72-15.19,1.3s-9.57-3.68-10.45-6.12c-2.84-7.92-1.83-11.7-2.77-13.19S41.58,200.28,41.58,200.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.53,210.05l4.61,1.18a2.35,2.35,0,0,1-2.85,1.8A2.5,2.5,0,0,1,54.53,210.05Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.06,210.83a2.84,2.84,0,0,0-.58,0A2.47,2.47,0,0,0,56.29,213a2.44,2.44,0,0,0,.76.05A2.18,2.18,0,0,0,55.06,210.83Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8,238.4c-1.41-1.71-6.06-4.16-8.19-1.87s-1.49,4.14-3,4c-2-.19-6.11-3.87-8.17-6.12a28.75,28.75,0,0,1-3.87-6.23,11.94,11.94,0,0,0,3-2.82c1.13-1.6,1.33-3.17,2.57-3.26l.14,3.55s.8,1.77,4.33,4.14S54.24,232.88,56.8,238.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8,238.4c1.16-1.07,2.74-3.76,4.65-3.22s2.91,3.91,3,2.89a29.44,29.44,0,0,0-3.22-9.1c-1.45-2.15-3.83-5.84-5.1-6.06v2.83s3.09,4.82,2.84,6.54S57,236.72,56.8,238.4Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.79,256.24a36.54,36.54,0,0,1-4.49-4.48,37,37,0,0,1-7.83-15.42c2-1.5,4.88-2.74,9.28-4.18l.09.13A28.39,28.39,0,0,1,28.63,244,37.87,37.87,0,0,1,27.79,256.24Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.36,255.27,29,257.19a36.41,36.41,0,0,1-5.67-5.43A37.06,37.06,0,0,1,15.39,236c3-2.23,7-3.6,9.44-4.51C31.69,238.47,29.36,255.27,29.36,255.27Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M141.78,237.84a2.36,2.36,0,1,1-2.36-2.36A2.36,2.36,0,0,1,141.78,237.84Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.42 238.34 116.37 238.34 103.39 228.09 89.23 228.09 89.23 227.09 103.74 227.09 116.71 237.34 139.42 237.34 139.42 238.34",
    style: {
      fill: "#51A2E5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 361.55,
    cy: 83.89,
    r: 38.4,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.55,46.49a37.4,37.4,0,1,1-37.4,37.4,37.39,37.39,0,0,1,37.4-37.4m0-2A39.4,39.4,0,1,0,401,83.89a39.44,39.44,0,0,0-39.4-39.4Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.59,84.49c-3.39,3-17.23,14.23-17.23,14.23-1.89-3.84-4.1-8.54-5.95-12.6a50.78,50.78,0,0,1-3.74-13.94,37.29,37.29,0,0,0-1.19-5.34,15.41,15.41,0,0,1-.49-5.53c.13-.91-2.18-1.24-3.33,1.48-.85,2-.74,4.39-.93,5.72-1-.56-2.47-1.67-4.67-2.85s-5.57-3.77-7.3-1.34c-.68,1,.05,2,0,2.27s-.41.48-.63.72a3.37,3.37,0,0,0-.63,3.36,1.82,1.82,0,0,1,.21.78c0,.55-.51,1-.68,1.46A3.4,3.4,0,0,0,286,74.7c.18.87.57,1.69.75,2.57a10,10,0,0,0,.41,1.61,4.53,4.53,0,0,0,2.19,2.71c1.42.83,2.9,1.71,5,2.88,1.63.92,2.39,3.56,3.39,7.89,2.75,10.13,3,16.68,5.44,22.18,3.23,7.14,8.09,6.13,17.09,1.08,11.06-6.2,19.05-10.48,19.05-10.48l8.93-28.61C342.5,76.91,336,81.49,332.59,84.49Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.55,75c-7.64.32-9.23,1.7-13.68,4.56s-17.35,14.21-17.35,14.21a30.76,30.76,0,0,0,9.74,16.36l14.49-8.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.92,68.68c1.68.72,2,1.91,1.75,4.39-.18,1.47,0,4.24,1.48,5.49a3.86,3.86,0,0,1-2-1.11c-.68-.86-.88-1-1.34-.56a2.79,2.79,0,0,1-1.17.52,1.94,1.94,0,0,1-.05,2.3c-.9,1.2-4.8.24-7.48-1.5,0,0,4.89,2.52,6.1,1.17s-1.48-4.06-3.24-4.74c0,0,4.77,2.14,5.59.76s-1.33-3.32-3.88-4.24c0,0,4,1.67,4.79.49C298.38,70.21,297.36,69.23,296.92,68.68Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.36,98.72c2.77,4.77,3.07,11.38,2.53,13.66,0,0,2.8-6.1-.58-15.24Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.83,109.48a37.39,37.39,0,0,1-49.78,4.29c.2-8.77-.05-15.8.29-19.29C340.76,79.7,344.83,75.7,352.39,75l12.53-.92c3.65.92,17,5.36,20.52,7.52,2.49,1.51,3.33,7.14,3.49,16.3C389,101.84,389,105.44,388.83,109.48Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.87,40.23a4.51,4.51,0,0,0,1.24,1,2.18,2.18,0,0,0-2,1.6,4.2,4.2,0,0,0,.23,2.66,7.33,7.33,0,0,0,2.11,3,16.54,16.54,0,0,0,3.45,1.77,16.43,16.43,0,0,1,2.19,1.84c1.05.8,2.09,1.62,3.16,2.4a67.5,67.5,0,0,0,6.66,4.3A48.23,48.23,0,0,0,365.83,62a19.93,19.93,0,0,0,6.38,1.21l.56,6.39s.88-1.69,1.89-3.7c.87-1.73,4.48-10.52,4.48-10.52,1.43-3.46,2.81-7.08,2.56-10.92-.19-3.11-1.14-5.42-3.52-6.72a7.58,7.58,0,0,0-2.83-7.66,14,14,0,0,0-6.23-2.3,25.45,25.45,0,0,0-7.54.32c-7,1.16-14.17,3.18-20.89-.23a5.91,5.91,0,0,0,.5,3.17,15.12,15.12,0,0,0,4,5.73l-3.92-.48a.6.6,0,0,0-.44.06.58.58,0,0,0-.16.42A4.79,4.79,0,0,0,341.87,40.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.43,38c0,2.27,2.21,6.28,5.45,9.06a22.78,22.78,0,0,0-.13,7.68,4,4,0,0,0,.59,1.53,1.88,1.88,0,0,0,1.35.85c.74,0,1.05-.4,1.27-1A20,20,0,0,1,376.07,54a4.16,4.16,0,0,1,.66-.83c1.12-1,4.45-2.34,6,1.2s-1.3,8.55-4,9.32c-4.63,1.32-5.65-1.83-5.65-1.83l.18,15.32c-1.28,3.9-8.44,7.71-14.24,7s-4-4.23-1.64-6.61l-.33-5.32a22.92,22.92,0,0,1-6.18-.18c-2.4-.45-4.86-2.43-5.88-6.08-1.94-7-1.23-17.14-.37-21.53s3.17-7.22,4.47-7.88c0,.94.74,3.2,5.42,3.82C359.51,41,362.87,39.47,366.43,38Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.09,72.2a34.27,34.27,0,0,0,10.15-2.34c3.52-1.77,3.84-5.55,4.23-6.64,0,0,0,5.75-3,8-3.68,2.74-11.28,3.19-11.28,3.19Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.43,46.55l3.73,1.82a2.17,2.17,0,0,0-1-2.85A2,2,0,0,0,361.43,46.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.16,61.57l-6,2.15a3.14,3.14,0,0,0,4,2A3.35,3.35,0,0,0,361.16,61.57Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.57,65.87a2.83,2.83,0,0,1,2.95-2.65,2.87,2.87,0,0,1,.72.14,3.27,3.27,0,0,1-2.06,2.4A3.05,3.05,0,0,1,357.57,65.87Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.42,47.83,350,45.89a2,2,0,0,0-2.7-.81A2.07,2.07,0,0,0,346.42,47.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.8 59.88 350.23 57.99 356.64 47.78 355.8 59.88",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.42,51.49a1.64,1.64,0,1,1-1.62-1.65A1.65,1.65,0,0,1,350.42,51.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.52,51.61A1.64,1.64,0,1,1,361.9,50,1.64,1.64,0,0,1,363.52,51.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.54,97.14a37.59,37.59,0,0,1-17.3,19.72c-.84-3.81-2.39-10.93-2.87-13.59-.68-3.71-1.81-18.72,9.07-21.68a31.84,31.84,0,0,1,6.69,4.12c1,1,2.64,1.8,3.74,7.46C396.06,94.18,396.29,95.56,396.54,97.14Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "337.58 163.72 336.97 162.92 361.05 144.46 361.05 121.29 362.05 121.29 362.05 144.95 361.86 145.1 337.58 163.72",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.92,163.32a2.36,2.36,0,1,0,2.36-2.36A2.36,2.36,0,0,0,334.92,163.32Z",
    style: {
      fill: "#51A2E5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115.09,
    cy: 83.89,
    r: 38.4,
    transform: "translate(-25.61 105.96) rotate(-45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.09,46.49a37.4,37.4,0,1,1-37.4,37.4,37.4,37.4,0,0,1,37.4-37.4m0-2a39.4,39.4,0,1,0,39.41,39.4,39.45,39.45,0,0,0-39.41-39.4Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.61,87.69c-1.55,4.27-4.69,7.93-8.26,11a29.06,29.06,0,0,1-7.79,5,35.4,35.4,0,0,1-7.46,1.91c-10.12,1.69-26,1.57-31.44-9.14A9.53,9.53,0,0,1,84.39,88c.81-1.61,2.2-3,2.35-4.82.19-2.41-1.91-4.34-2.63-6.65-1.13-3.64,1.64-6.73,4.33-8.8,3.3-2.53,3.75-3.92,3.89-6.89,0-1.36-.39-2.7-.47-4a16.89,16.89,0,0,1,1.91-8.33,11,11,0,0,1,6.15-5c.08,0,28.34-.72,28.34-.72.35,1.62.78,3.25,1,4.86.36,2.55,1.93,4.16,3.5,6.19,1.68,2.27,3.44,4.68,3.38,7.52s-2,5.86-1.34,8.67c.54,2,2.3,3.41,3.53,5.05C140.94,78.55,141.15,83.43,139.61,87.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.68,81.13c11.57-1.08,13,1,22.94,7.66,6.72,4.51,15.53,10.45,15.53,10.45s5.95-19.19,5.76-22c-.22-3.36-1.92-5.18-2.8-8.68s-.93-5.92-1.93-7.33,1.93-2,3.31-.3,1.75,4.33,2.53,3.79.85-6.2-.23-10.17,1.08-5.23,2-4a11,11,0,0,1,1.35,2.06,8.15,8.15,0,0,1,1.07-.3,1.73,1.73,0,0,1,1.56.23c.45.33.8.79,1.27,1.07a9.74,9.74,0,0,0,1.59.58c3.86,1.44,4.17,7.79,4.35,11.14.38,7-2.47,10.81-3.15,13.46-.26,1-.29,4.16-.78,10.83-.56,7.62-.81,15.4-3.53,23.24-2.27,6.57-6.85,6.31-11.71,4.33-6.94-2.83-27.19-13.92-27.19-13.92C131.46,94.92,127.68,81.13,127.68,81.13Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.1,66.34s4.57,2.27,3.85,8.94c0,0,2-3.63.2-6.37S175.1,66.34,175.1,66.34Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.15,99.24s-1.84,4-.58,11a14.93,14.93,0,0,1-1-12.06Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.24,106a37.31,37.31,0,0,1-54.08,6.59,103,103,0,0,1-.14-12.3,32.3,32.3,0,0,1,.76-6.58,17.76,17.76,0,0,1,2.1-5c1.46-2.36,4.09-3.47,6.91-4.16,2.26-.56,4.65-.86,6.65-1.32l2.86-.67,12.6-1.08,4.53-.39C133.16,83.89,140.59,92,144,99.92A13,13,0,0,1,145.24,106Z",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,106a37.31,37.31,0,0,1-54.08,6.59,103,103,0,0,1-.14-12.3,32.3,32.3,0,0,1,.76-6.58,17.76,17.76,0,0,1,2.1-5c1.46-2.36,4.09-3.47,6.91-4.16,2.26-.56,4.65-.86,6.65-1.32l2.86-.67,12.6-1.08,4.53-.39C133.16,83.89,140.59,92,144,99.92A13,13,0,0,1,145.24,106Z",
    style: {
      fill: "#fff",
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.15,100.07c-.5,4-2.25,8-3.85,11.69l-2.48,5.82a37.85,37.85,0,0,1-14.3-12.15c1-3,2.5-6.89,4.07-10.32,3.08-6.73,4.38-9.29,12.2-10.49C105.15,87.29,105.89,94,105.15,100.07Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.11,75.33c.26-1.1-2-5-3.25-6.65-3.84-4.77-5.77-6-7.27-12.15-1-4.1-.3-8.65,3.33-13.07,2.76-6.8,7.26-10,15.26-11.14a35,35,0,0,1,10.53.39c1.49.33,3,.8,4.46,1a8.63,8.63,0,0,0,4.61-.38c.77-.32,1.69-.8,2.34-.36a1.52,1.52,0,0,1,.53,1.2,5.45,5.45,0,0,1-2.54,4.73,4.31,4.31,0,0,1,3,8,3.6,3.6,0,0,1,.56,4.42A8.54,8.54,0,0,1,135,54.25c-4.37,2.27-8.07,5.6-11.92,8.61l-11,8.62-3.59,2.81C108.29,74.4,107.11,75.15,107.11,75.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.33,40.18c4.25,1.77,8,4.44,7.8,19.06-.17,11.27-3.67,14.36-5.58,15.33a17.44,17.44,0,0,1-8.66,1.2l0,6.86s10.92,9,7.27,15.82c-18-4.2-22.73-14.62-22.73-14.62l-.66-16.44a4.37,4.37,0,0,1-4.82.44,6.16,6.16,0,0,1-2-9.55c2.26-2.43,5.82-2,7.23.5,0,0-1.77-10.62,4.55-15.44C119.2,37.67,124.34,38.11,129.33,40.18Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.39,59.5l0-.17a2.76,2.76,0,0,0-1-1.45,2.9,2.9,0,0,0-1.2-.72,3.1,3.1,0,0,0-3.15,1.15,6.77,6.77,0,0,0-1.44,2.87,3.59,3.59,0,0,1,.1-2,5.73,5.73,0,0,1,2.43-3.12,4.41,4.41,0,0,1,3.87-.36,3.66,3.66,0,0,1,2.2,2.85c.24,1.57-.64,2.51-1.69,3.54a1.41,1.41,0,0,1-.46.34.49.49,0,0,1-.53-.08.56.56,0,0,1,0-.63c.17-.35.41-.68.61-1A2.19,2.19,0,0,0,105.39,59.5Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.88,64a1.27,1.27,0,0,1-.12.73c-.37.65-1.4.63-2,.44a4.12,4.12,0,0,1-2-1.33c-.9-1.12-1.41-3.09,0-4.05a2,2,0,0,1,2.82.4,3.74,3.74,0,0,1,.35,1.93,1.3,1.3,0,0,0,.26.82,2.83,2.83,0,0,1,.62.76A1.33,1.33,0,0,1,105.88,64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.06,66.33a2.66,2.66,0,0,0,2.43,3.13A3.2,3.2,0,0,0,128,67Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.41,69.41a2.31,2.31,0,0,0-2.55-2.21,2.53,2.53,0,0,0-.78.17,2.7,2.7,0,0,0,2.41,2.09A3.53,3.53,0,0,0,125.41,69.41Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.85,56.77a1.66,1.66,0,0,1-1.59,1.61,1.45,1.45,0,0,1-1.6-1.41,1.66,1.66,0,0,1,1.59-1.61A1.45,1.45,0,0,1,121.85,56.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.7,55.31a1.67,1.67,0,0,1-1.59,1.61,1.45,1.45,0,0,1-1.6-1.42,1.66,1.66,0,0,1,1.59-1.6A1.44,1.44,0,0,1,133.7,55.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.11 54.26 127.06 62.99 132.61 61.43 126.11 54.26",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.89,75.77c-3.31-.33-10.67-1.56-13.83-6.74a10.35,10.35,0,0,0,2.69,5.24c3.19,3,11.15,4.15,11.15,4.15Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.17,51.61l-3.47,2.77a2.15,2.15,0,0,1,.39-3A2.21,2.21,0,0,1,120.17,51.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.56,51.58l-4.13-1.32a2.28,2.28,0,0,1,2.82-1.38A2.05,2.05,0,0,1,134.56,51.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.36,44.66c-1.86.42-4.08-2.37-7.8-.9-4,1.59-2.71,5.77-5.57,8.28-2.16,1.9,0,6.66-2.32,7.79-1,.5-2.44-1-2.44-1s-2-2.72-1.56-9.29S115.31,38,122,37.33s13.55,3.06,13.58,8.94c0,0-1.66-3.53-4.8-3.79S127,44.28,125.36,44.66Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "218.22 224.57 114.59 144.95 114.59 121.29 115.59 121.29 115.59 144.46 218.83 223.78 218.22 224.57",
    style: {
      fill: "#51A2E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.88,224.17a2.36,2.36,0,1,1-2.36-2.35A2.36,2.36,0,0,1,220.88,224.17Z",
    style: {
      fill: "#51A2E5"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.e4904f39bfbd7657b10adc47d8758f0d.svg";
export { ForwardRef as ReactComponent };